export const contentItalian = {
  code: "IT",
  labels: {
    // App Digital Admin
    digitalAdmin: "Digital Admin",
    digitalAdminApp: "App Digital Admin",
    digitalAdminSarl: "Digital Admin SARL",
    copilotTitle: "Digital Copilot",
    copilotComingSoon: "Il tuo assistente IA arriva presto",
    copilotOpen: "Apri Copilot",
    copilotClose: "Chiudi Copilot",
    copilotPlaceholder: "Fai una domanda al tuo assistente IA",
    copilotInputPlaceholder: "Scrivi il tuo messaggio...",
    copilotSend: "Invia",
    copilotConnected: "Connesso",
    copilotConnecting: "Connessione...",
    copilotDisconnected: "Disconnesso",
    copilotConnectionLost: "Connessione persa",
    copilotReconnect: "Riconnetti",
    copilotToolRunning: "Ricerca in corso",
    copilotActionProposed: "Azione proposta",
    copilotConfirm: "Conferma",
    copilotReject: "Rifiuta",
    copilotConfirming: "Confermando...",
    copilotRejecting: "Rifiutando...",
    copilotActionBlockInput: "Conferma o rifiuta l'azione proposta per continuare",
    copilotActionHint: "Conferma, rifiuta o scrivi una correzione",
    copilotActionCreateContact: "Nuovo contatto",
    copilotActionCreateInvoice: "Nuova fattura cliente",
    copilotActionCreateQuote: "Nuovo preventivo",
    copilotActionCreateOrder: "Nuovo ordine cliente",
    copilotActionCreateProviderInvoice: "Nuova fattura fornitore",
    copilotActionCreateProviderOrder: "Nuovo ordine fornitore",
    copilotActionCreateExpense: "Nuova spesa",
    copilotActionCreateAccountingEntry: "Nuova registrazione contabile",
    copilotResultContactCreated: "Contatto creato",
    copilotResultInvoiceCreated: "Fattura cliente creata",
    copilotResultQuoteCreated: "Preventivo creato",
    copilotResultOrderCreated: "Ordine cliente creato",
    copilotResultProviderInvoiceCreated: "Fattura fornitore creata",
    copilotResultProviderOrderCreated: "Ordine fornitore creato",
    copilotResultExpenseCreated: "Spesa creata",
    copilotResultAccountingEntryCreated: "Registrazione contabile creata",
    copilotResultGeneric: "Azione completata",
    copilotResultFailed: "L'azione non e riuscita",
    copilotDiscussDocument: "Discuti con il Copilot",
    copilotDocumentAttached: "Documento allegato",
    copilotDetachDocument: "Scollega",
    copilotViewPiece: "Vedi il documento",
    copilotAttachDocument: "Allega un documento",
    copilotSearchExisting: "Cerca esistente",
    copilotUploadNew: "Carica nuovo",
    copilotSearchPlaceholder: "Cerca per nome...",
    copilotUploading: "Caricamento...",
    copilotUploadError: "Caricamento fallito",
    copilotNoDocuments: "Nessun documento trovato",
    uploadingFile: "Caricamento file in corso...",
    uploadProgress: "Progresso del caricamento",
    zipExtractionStarted: "Estrazione ZIP avviata",
    zipExtractionInProgress: "Il file ZIP viene estratto in background. I documenti appariranno a breve.",
    uploadFailed: "Caricamento fallito",
    uploadTooLarge: "Il file supera la dimensione massima consentita",
    copilotOnline: "Online",
    copilotYou: "Tu",
    copilotHistory: "Cronologia",
    copilotNewConversation: "Nuova conversazione",
    copilotNoThreads: "Nessuna conversazione",
    copilotActionRejected: "Azione rifiutata",
    copilotActionFailedPast: "Azione fallita",
    copilotLoadingMessages: "Caricamento messaggi...",
    copilotSuggestCreateExpense: "Creare una spesa",
    copilotSuggestCreateProviderInvoice: "Creare una fattura fornitore",
    copilotSuggestMsgCreateExpense: "Crea una spesa dal documento allegato.",
    copilotSuggestMsgCreateProviderInvoice: "Crea una fattura fornitore dal documento allegato.",
    copilotActionStartBatch: "Elaborazione batch",
    copilotBatchConfirmText: "Elabora automaticamente tutti i documenti in sospeso. Il copilota analizzerà e creerà le voci corrispondenti.",
    copilotBatchMilestone: "Elaborazione batch",
    copilotSuggestProcessDocuments: "Elabora i miei documenti",
    copilotSuggestMsgProcessDocuments: "Elabora automaticamente tutti i miei documenti in sospeso.",
    viewDocument: "Visualizza documento",
    digitalAdminPro: "Digital Admin Pro",
    welcomeToDigitalAdmin: "Benvenuto in Digital Admin",
    purchasePro: "Acquista Digital Admin Pro",
    signIn: "Accedi a Digital Admin",

    // Words sentences
    about: "Informazioni",
    successful: "Riuscito",
    error: "Errore",
    accountSettings: "Impostazioni account",
    actions: "Azioni",
    additional: "Aggiuntivo",
    address: "Indirizzo",
    administrativeArea: "Cantone",
    amount: "Importo",
    sum: "Somma",
    amountTotal: "Importo totale",
    apply: "Applica",
    approved: "Approvato",
    ascending: "Crescente",
    addContact: "Aggiungi contatto",
    addContent: "Aggiungi contenuto",
    addSignature: "Aggiungi firma",
    avatar: "Avatar",
    back: "Indietro",
    bban: "BBAN",
    bicSwift: "BIC/SWIFT",
    bimester: "Bimestre",
    calculatedValuesAreReferential: "I valori calcolati sono indicativi",
    cancel: "Annulla",
    canceled: "Annullato",
    city: "Città",
    comment: "Commento",
    completed: "Completato",
    companyContact: "Contatto aziendale",
    content: "Contenuto",
    registerNumber: "Numero di registrazione",
    concerning: "Riguardante",
    contactInformation: "Informazioni di contatto",
    continue: "Continua",
    country: "Paese",
    create: "Crea",
    createdDate: "Data di creazione",
    currency: "Valuta",
    customer: "Cliente",
    date: "Data",
    day: "Giorno",
    days: "Giorni",
    default: "Predefinito",
    delete: "Elimina",
    descending: "Decrescente",
    description: "Descrizione",
    detail: "Dettaglio",
    details: "Dettagli",
    discard: "Scarta",
    doNotGroup: "Non raggruppare",
    edit: "Modifica",
    email: "Email",
    end: "Fine",
    endDate: "Data di fine",
    excel: "Excel",
    export: "Esporta",
    filter: "Filtro",
    filterOptions: "Opzioni filtro",
    firstName: "Nome",
    group: "Gruppo",
    halfYear: "Semestre",
    iban: "IBAN",
    identity: "Identità",
    inProgress: "In corso",
    justNow: "Proprio ora",
    lastDay: "Ultimo giorno",
    lastName: "Cognome",
    legalInformation: "Informazioni legali",
    list: "Elenco",
    location: "Posizione",
    menu: "Menu",
    message: "Messaggio",
    messages: "Messaggi",
    archived: "Archiviato",
    read: "Leggi",
    unread: "Non letto",
    archive: "Archiviare",
    noNumber: "Nessun numero",
    noMatchingRecordsFound: "Nessun record corrispondente trovato",
    month: "Mese",
    months: "Mesi",
    number: "Numero",
    sortAlphabetically: "Ordina alfabeticamente",
    pages: "Pagine",
    pdf: "PDF",
    pending: "In sospeso",
    person: "Persona",
    phone: "Telefono",
    phoneNumber: "Numero di telefono",
    priceGross: "Prezzo lordo",
    priceNet: "Prezzo netto",
    priceTotal: "Prezzo totale",
    product: "Prodotto",
    products: "Prodotti",
    qrIban: "QR-IBAN",
    quantity: "Quantità",
    stockLimitReached: "Limite di magazzino raggiunto",
    lowStockWarning: "Avviso di scorte basse",
    accepted: "Accettato",
    declined: "Rifiutato",
    rejected: "Rifiutato",
    sent: "Inviato",
    remove: "Rimuovi",
    removeReference: "Rimuovi riferimento",
    removeContent: "Rimuovi contenuto",
    removeSignature: "Rimuovi firma",
    removeRequirement: "Rimuovi blocco",
    removeVoucher: "Rimuovi voucher",
    requirement: "Blocco",
    requirements: "Blocchi",
    reset: "Resetta",
    saveChanges: "Salva modifiche",
    searchResults: "Risultati ricerca",
    selectExportFormat: "Seleziona formato di esportazione",
    send: "Invia",
    service: "Servizio",
    services: "Servizi",
    appService: "Servizio applicativo",
    appServices: "Servizi applicativi",
    signature: "Firma",
    signatures: "Firme",
    start: "Inizio",
    startDate: "Data di inizio",
    status: "Stato",
    street: "Via",
    subTotal: "Subtotale",
    support: "Supporto",
    symbol: "Simbolo",
    tax: "Tassa",
    taxSale: "Imposta sulle vendite",
    taxPurchase: "Imposta sugli acquisti",
    taxRate: "Aliquota fiscale",
    taxTotal: "Totale tasse",
    trimester: "Trimestre",
    total: "Totale",
    totalAmount: "Importo totale",
    top: "Alto",
    type: "Tipo",
    timeInterval: "Intervallo di tempo",
    interval: "Intervallo",
    unitMeasure: "Unità di misura",
    unitPrice: "Prezzo unitario",
    update: "Aggiorna",
    validity: "Validità",
    value: "Valore",
    vatNumber: "Numero IVA/IDE",
    contactCode: "Codice contatto",
    webSite: "Sito internet",
    week: "Settimana",
    weeks: "Settimane",
    view: "Visualizza",
    yes: "Sì",
    zipCode: "CAP",
    gross: "Lordo",
    net: "Netto",
    rebate: "Sconto",
    rebateTotal: "Sconto totale",
    selectOptionAddAmountPercentageDesired: "Seleziona un'opzione e aggiungi l'importo o la percentuale desiderata",
    changeImage: "Cambia immagine",
    changeLogo: "Cambia logo",
    exportError: "Errore di esportazione",
    failedToLoadTheScript: "Caricamento dello script fallito",
    identificationNumberForACompany: "Numero identificativo di una società per operazioni europee",
    internationalBankAccountNumberIban: "Numero di conto bancario internazionale (IBAN)",
    listOfCompaniesIHaveAccess: "Elenco delle aziende a cui ho accesso",
    noRecordsFound: "Nessun record trovato",
    noResultsFound: "Nessun risultato trovato",
    companyNotSubjectToVat: "Nessun rendiconto IVA",
    companyNotSubjectToVatDescription: "Questa società non è soggetta all'IVA. Non sono disponibili periodi di rendiconto.",
    removeImage: "Rimuovi immagine",
    selectTheTypeOfContact: "Seleziona il tipo di contatto che vuoi creare",
    specifyTheUniqueUUID: "Specifica l'UUID unico di un utente o di una società",
    theDefaultBankAccountIsTheCompanys: "Il conto tesoreria predefinito è quello della società",
    theDefaultCurrencyIsTheCompanys: "La valuta predefinita è quella della società",
    theDefaultShapeOrVersionOfAQrInvoiceToDownloadIsTheClients:
      "La forma o versione predefinita di una fattura QR da scaricare è quella del cliente",
    theDefaultLanguageToDownloadIsTheClients: "La lingua predefinita da scaricare è quella del cliente",
    youMustAcceptTheTermsAndConditions: "Devi accettare i termini e le condizioni",
    acceptingInvitationToAccessCompany: "Accettazione dell'invito ad accedere alla società",
    verificationYourAccount: "Verifica del tuo account",
    addCompany: "Aggiungi azienda",
    allInLicense: "Licenza tutto incluso",
    buyNow: "Acquista ora",
    comingSoon: "Prossimamente",
    licenseTerms: "Termini della licenza",
    pageNotFound: "Pagina non trovata",
    viewInvitations: "Visualizza inviti",
    purchase: "Acquista",
    reload: "Ricarica",
    systemError: "Errore di sistema",
    dashboard: "Dashboard",
    abbreviation: "Abbreviazione",
    amountPurchases: "Importo acquisti",
    amountSales: "Importo vendite",
    best: "Migliore",
    companyInsight: "Analisi aziendale",
    comparativeInterval: "Intervallo comparativo",
    comparisonIncomeAndExpenses: "Confronto tra entrate e spese",
    customerPayments: "Pagamenti clienti",
    customRange: "Intervallo personalizzato",
    debtPercent: "Debito (%)",
    distributionOfQuotes: "Distribuzione dei preventivi per stato",
    distributionOfOrders: "Distribuzione degli ordini per stato",
    expirationDate: "Data di scadenza",
    creationDate: "Data di creazione",
    invoicesStillToBePaid: "Fatture ancora da pagare",
    invoicesStillToBePaidByTheCustomer: "Fatture ancora da pagare dal cliente",
    invoicesWithMoreDebt: "Fatture con più debito",
    ordersByState: "Ordini per stato",
    ordersToBilled: "Ordini da fatturare",
    paidPercent: "Pagato (%)",
    percentage: "Percentuale",
    quotesByState: "Preventivi per stato",
    quotesAccepted: "Preventivi accettati",
    quotesApproved: "Preventivi approvati",
    quotesToExpire: "Preventivi in scadenza",
    retailAnalysisSample: "Campione di analisi retail",
    representationOfSalesAndPurchases: "Rappresentazione delle vendite e degli acquisti per mese su un anno",
    salesVsPurchases: "Vendite vs Acquisti",
    thisBimester: "Questo bimestre",
    thisTrimester: "Questo trimestre",
    thisHalfYear: "Questo semestre",
    thisMonth: "Questo mese",
    thisWeek: "Questa settimana",
    thisYear: "Quest'anno",
    today: "Oggi",
    turnout: "Importo fattura",
    viewAll: "Visualizza tutto",
    worst: "Peggiore",
    yesterday: "Ieri",
    fixedAmount: "Importo fisso",
    discount: "Sconto",
    account: "Account",
    changeEmail: "Cambia email",
    changePassword: "Cambia password",
    confirmNewPassword: "Conferma nuova password",
    currentPassword: "Password corrente",
    emailAddress: "Indirizzo email",
    enterNewEmailAddress: "Inserisci un nuovo indirizzo email",
    fullName: "Nome completo",
    newPassword: "Nuova password",
    pleaseCheckYourEmailInbox: "Controlla la tua casella email",
    profileCompleation: "Completamento profilo",
    profileDetails: "Dettagli profilo",
    signInMethod: "Metodo di accesso",
    updateEmail: "Aggiorna email",
    updatePassword: "Aggiorna password",
    updateUser: "Aggiorna utente",
    validateAccount: "Valida account",
    viewUser: "Visualizza utente",
    user: "Utente",
    users: "Utenti",
    confirmPassword: "Conferma password",
    createAnAccount: "Crea un account",
    enterYourEmailToResetYourPassword: "Inserisci la tua email per reimpostare la password",
    goToLoginPage: "Vai alla pagina di accesso",
    goToPreviousPage: "Torna alla pagina precedente",
    language: "Lingua",
    languages: "Lingue",
    myProfile: "Il mio profilo",
    notVerified: "Non verificato",
    password: "Password",
    resetPassword: "Reimposta password",
    signInHere: "Accedi qui",
    signOut: "Esci",
    submit: "Invia",
    userProfile: "Profilo utente",
    use8OrMoreCharacters: "Usa 8 o più caratteri con combinazione di lettere maiuscole e minuscole, numeri e simboli",
    verified: "Verificato",
    welcome: "Benvenuto",
    company: "Azienda",
    companies: "Aziende",
    current: "Attuale",
    addDeadlinePaymentParameter: "Aggiungi parametro scadenza pagamento",
    addFeatureParameter: "Aggiungi parametro di funzionalità",
    addImage: "Aggiungi immagine",
    addTax: "Aggiungi tassa",
    addDeadline: "Aggiungi scadenza",
    addFeature: "Aggiungi funzionalità",
    addTaxRateParameter: "Aggiungi parametro aliquota fiscale",
    addUnit: "Aggiungi unità",
    addUnitMeasureParameter: "Aggiungi parametro unità di misura",
    advanceSettings: "Impostazioni avanzate",
    aNewCompanyWillBeCreated: "Verrà creata una nuova azienda basata sui dati inseriti",
    browseUsers: "Sfoglia utenti",
    companyAddress: "Indirizzo azienda",
    companyAdvanceSettings: "Impostazioni avanzate azienda",
    companyDownloadSettings: "Impostazioni download azienda",
    companyAccountingSettings: "Impostazione della contabilità aziendale",
    companyGeneralSettings: "Configurazione dei parametri generali dell'azienda",
    companyInformationSettingGeneral: "Impostazione delle informazioni generali dell'azienda",
    companyIdentity: "Identità azienda",
    companyLogo: "Logo azienda",
    companyName: "Nome azienda",
    legalForm: "Forma giuridica",
    legalFormSarl: "Sagl",
    legalFormSa: "SA",
    legalFormRi: "Ditta individuale",
    legalFormSnc: "Società in nome collettivo (SNC)",
    legalFormCooperative: "Società cooperativa",
    legalFormAssociation: "Associazione",
    legalFormFondation: "Fondazione",
    legalFormAutre: "Altro",
    createCompany: "Crea azienda",
    createAndSave: "Crea & Salva",
    newCompany: "Nuova azienda",
    designOfDocumentToDownloadQuotesAndInvoices: "Progettazione documento per scaricare preventivi, ordini e fatture",
    downloadSettings: "Impostazioni download",
    dueDates: "Date di scadenza pagamento fattura",
    editCompany: "Modifica azienda",
    free: "Gratuito",
    generalSettings: "Impostazioni generali",
    helpPage: "Pagina di aiuto",
    image: "Immagine",
    inviteAccessCompany: "Invitare ad accedere all’azienda",
    legal: "Legale",
    listUsers: "Elenco utenti",
    logo: "Logo",
    name: "Nome",
    new: "Nuovo",
    noResultFound: "Nessun risultato trovato",
    overview: "Panoramica",
    accountingSettings: "Impostazioni contabilità",
    pleaseTryAgainWithADifferentQuery: "Riprova con una query diversa",
    predefinedTaxesFees: "Tasse e commissioni predefinite",
    predefinedValues: "Valori predefiniti",
    freeInput: "Inserimento libero",
    inputMethod: "Metodo di inserimento",
    private: "Privato",
    removeLogo: "Rimuovi logo",
    selectModel: "Seleziona modello",
    selectAndSaveDesiredLayoutToDownload: "Seleziona e salva il layout desiderato per scaricare preventivo, ordine e fattura",
    selectAndSaveOneToFourDesiredColors:
      "Seleziona e salva da uno a quattro colori desiderati per il design di preventivo, ordine e fattura",
    sendInvitation: "Invia invito",
    settings: "Impostazioni",
    taxValue: "Valore tassa",
    templateColors: "Colori modello",
    templateModel: "Modello template",
    unitsOfMeasure: "Unità di misura per un servizio o un prodotto",
    characteristicsForServiceProduct: "Caratteristiche di un servizio o di un prodotto",
    uuidCode: "Codice UUID",
    uuidCompany: "UUID azienda",
    uuidOrName: "UUID/Nome",
    usersWhoAreSubscribed: "Utenti iscritti e con accesso all'azienda",
    viewCompany: "Visualizza azienda",
    viewMoreUsers: "Visualizza più utenti",
    treasury: "Tesoreria",
    treasuryAccount: "Conto tesoreria",
    treasuryCashAccount: "Conto Tesoreria Contanti",
    treasuryCardAccount: "Conto Tesoreria Carta",
    noCashTreasuryAccounts: "Nessun conto di tesoreria contanti disponibile",
    noCardTreasuryAccounts: "Nessun conto di tesoreria carta disponibile",
    conceptAccount: "Conto concettuale",
    treasuryAccounts: "Conti tesoreria",
    codeOfBelongingToABankingOrganization: "Codice di appartenenza a un'organizzazione bancaria",
    createNewTreasuryAccount: "Crea nuovo conto tesoreria",
    createTreasuryAccount: "Crea conto tesoreria",
    listTreasuryAccounts: "Elenco conti tesoreria",
    listBookingJournals: "Elenco registri contabili",
    listAccountingAccounts: "Elenco conti contabili",
    viewBookingJournal: "Visualizza registro contabile",
    membership: "Membro",
    nameOfAccount: "Nome conto",
    contactUs: "Contattaci",
    typeOfTreasuryAccount: "Tipo di conto tesoreria",
    updateTreasuryAccountData: "Aggiorna dati conto tesoreria",
    viewTreasuryAccountsList: "Visualizza elenco conti tesoreria",
    notification: "Notifica",
    notifications: "Notifiche",
    accept: "Accetta",
    accessToCompany: "Accesso all'azienda",
    activities: "Attività",
    answers: "Risposte",
    close: "Chiudi",
    companyInvitations: "Inviti aziendali",
    hasReceivedANotification: "Ha ricevuto una notifica",
    hasReceivedAQuote: "Ha ricevuto un preventivo",
    hasReceivedAnInvitation: "Ha ricevuto un invito",
    hasReceivedAnOrder: "Ha ricevuto un ordine",
    newNotification: "Nuova notifica",
    noNotifications: "Nessuna notifica",
    noInvitations: "Non ci sono inviti",
    other: "Altro",
    quoteEvaluation: "Valutazione preventivo",
    quoteNotification: "Notifica preventivo",
    approve: "Approva",
    reject: "Rifiuta",
    contact: "Contatto",
    contacts: "Contatti",
    basicBankAccountNumber: "Numero conto tesoreria base",
    bankIdentifierCode: "Codice identificativo bancario / Society for worldwide interbank financial telecommunication",
    listContacts: "Elenco contatti",
    contactUUID: "UUID contatto",
    contactIdentity: "Identità contatto",
    contactIsNotAnAppUser: "Il contatto non è un utente dell'app",
    contactType: "Tipo di contatto",
    contactUuidAndType: "UUID e tipo contatto",
    countryContact: "Paese contatto",
    createContact: "Crea contatto",
    createNewContact: "Crea nuovo contatto",
    createContactCompanyStructure: "Crea una struttura contatto tipo azienda",
    createContactPersonStructure: "Crea una struttura contatto tipo persona",
    deleteContact: "Elimina contatto",
    deleteSelected: "Elimina selezionati",
    definingTheIdentityOfContact: "Definizione dell'identità del contatto",
    definingTheInformationOfContact: "Definizione delle informazioni del contatto",
    definingTheLegalInformationOfContact: "Definizione delle informazioni legali del contatto",
    definingTheSettingsToDownloadQuotesAndInvoices: "Definizione delle impostazioni per scaricare preventivi e fatture",
    dragOrClickOnTheBoxToAddTheCompanyLogo: "Trascina o clicca sulla casella per aggiungere il logo aziendale",
    editContact: "Modifica contatto",
    enterThePostalCodeOfTheCity: "Inserisci il CAP della città",
    exportContacts: "Esporta contatti",
    exportEntryContacts: "Esporta registrazione contabile",
    extendChanges: "Estendi modifiche",
    fileDownloadSettings: "Impostazioni download file",
    financialEntity: "Ente finanziario",
    identityOfContact: "Identità del contatto",
    ifAddressDoesNotHaveANumber: "Se l'indirizzo non ha numero, inserisci 'nn' o 'NN'",
    whenNumberIsNotEntered: "Quando il numero non viene inserito, viene rappresentato da 'NN'",
    ifNecessaryEnterSomethingReferentialRegardingAddress: "Se necessario inserisci qualcosa di riferimentale riguardo l'indirizzo",
    informationOfContact: "Informazioni del contatto",
    internationalBankAccountNumber: "Numero di conto bancario internazionale",
    languageToDownload: "Lingua per scaricare preventivo, ordine o fattura",
    legalInformationOfContact: "Informazioni legali del contatto",
    qrType: "Tipo di QR-fattura",
    shapesOrVersionsOfQR: "Forme o versioni di una fattura QR",
    basicCurrencyCompany: "Valuta base della società",
    selectCompanyAndSave: "Seleziona azienda e salva",
    selectCompaniesToCreateContact: "Seleziona le aziende a cui aggiungere il nuovo contatto",
    typeOfContact: "Tipo di contatto",
    updateContactData: "Aggiorna dati contatto",
    uuidAndType: "UUID e tipo",
    userUuid: "UUID utente",
    viewContact: "Visualizza contatto",
    addresses: "Indirizzi",
    addAddress: "Aggiungi indirizzo",
    editAddress: "Modifica indirizzo",
    deleteAddress: "Elimina indirizzo",
    addressLabel: "Etichetta indirizzo",
    addressType: "Tipo di indirizzo",
    deliveryType: "Consegna",
    billingType: "Fatturazione",
    otherType: "Altro",
    defaultDeliveryAddress: "Indirizzo di consegna predefinito",
    setAsDefault: "Imposta come predefinito",
    mainAddressBadge: "Principale",
    noAddressesYet: "Nessun indirizzo aggiunto",
    quote: "Preventivo",
    quotes: "Preventivi",
    addQuote: "Aggiungi preventivo",
    approveQuote: "Approva preventivo",
    companyQuoteList: "Elenco preventivi azienda",
    createQuote: "Crea preventivo",
    newQuote: "Nuovo preventivo",
    dateOfDocument: "Data del documento, può essere modificata in seguito",
    editQuote: "Modifica preventivo",
    enterADateOrSelectADefaultPaymentDeadline: "Inserisci una data o seleziona una scadenza di pagamento predefinita",
    expired: "Scaduto",
    exportQuotes: "Esporta preventivi",
    generateQuote: "Genera preventivo",
    inTime: "In tempo",
    listQuotes: "Elenco preventivi",
    quoteDate: "Data preventivo",
    quoteGroups: "Gruppi preventivi",
    quoteNumber: "Numero preventivo",
    quoteReference: "Riferimento preventivo",
    quoteStatus: "Stato preventivo",
    quoteValidity: "Validità preventivo",
    rejectQuote: "Rifiuta preventivo",
    sendQuote: "Invia preventivo",
    updateQuote: "Aggiorna preventivo",
    viewQuote: "Visualizza preventivo",
    purchases: "Acquisti",
    sales: "Vendite",
    sale: "Vendita",
    principal: "Principale",
    humanResources: "Risorse umane",
    closingJournal: "Giornale di chiusura",
    manuallyCreated: "Creato manualmente",
    expenses: "Spese",
    addExpense: "Aggiungi spesa",
    createExpense: "Crea spesa",
    editExpense: "Modifica spesa",
    expenseDate: "Data spesa",
    expenseGroups: "Gruppi spesa",
    expenseNumber: "Numero spesa",
    expenseValidity: "Validità spesa",
    invalidateExpense: "Annulla spesa",
    listExpenses: "Elenco spese",
    removeExpense: "Rimuovi spesa",
    updateExpense: "Aggiorna spesa",
    validateExpense: "Convalida spesa",
    viewExpense: "Visualizza spesa",
    addProviderInvoice: "Aggiungi fattura fornitore",
    createProviderInvoice: "Crea fattura fornitore",
    editProviderInvoice: "Modifica fattura fornitore",
    invalidateProviderInvoice: "Annulla fattura fornitore",
    listProviderInvoices: "Elenco fatture fornitori",
    myTreasuryAccount: "Il mio conto tesoreria",
    provider: "Fornitore",
    providerBankAccount: "Conto bancario fornitore",
    providerInvoiceDate: "Data fattura fornitore",
    providerInvoiceGroups: "Gruppi fattura fornitore",
    providerInvoiceStatus: "Stato fattura fornitore",
    providerInvoiceValidity: "Validità fattura fornitore",
    providerInvoices: "Fatture fornitori",
    providerOrderNumber: "Numero ordine fornitore",
    updateProviderInvoice: "Aggiorna fattura fornitore",
    validateProviderInvoice: "Convalida fattura fornitore",
    viewProviderInvoice: "Visualizza fattura fornitore",
    addProviderOrder: "Aggiungi ordine fornitore",
    approveProviderOrder: "Approva ordine fornitore",
    cancelProviderOrder: "Annulla ordine fornitore",
    createProviderOrder: "Crea ordine fornitore",
    editProviderOrder: "Modifica ordine fornitore",
    generateProviderInvoice: "Genera fattura fornitore",
    generateProviderOrder: "Genera ordine fornitore",
    listProviderOrders: "Elenco ordini fornitori",
    providerOrderDate: "Data ordine fornitore",
    providerOrders: "Ordini fornitori",
    providerOrderGroups: "Gruppi ordine fornitore",
    providerOrderReference: "Riferimento ordine fornitore",
    providerInvoiceReference: "Riferimento fattura fornitore",
    expenseReference: "Riferimento spesa",
    providerOrderStatus: "Stato ordine fornitore",
    updateProviderOrder: "Aggiorna ordine fornitore",
    viewProviderOrder: "Visualizza ordine fornitore",
    providerQuote: "Preventivo fornitore",
    providerQuotes: "Preventivi fornitori",
    listProviderQuotes: "Lista preventivi fornitori",
    viewProviderQuote: "Visualizza preventivo fornitore",
    sourceQuoteNumber: "Rif. preventivo origine",
    sourceCompany: "Azienda emittente",
    acceptQuote: "Accetta preventivo",
    declineQuote: "Rifiuta preventivo",
    internalNotes: "Note interne",
    saveNotes: "Salva note",
    providerQuoteAccepted: "Preventivo accettato, ordine fornitore creato",
    providerQuoteDeclined: "Preventivo rifiutato",
    confirmAcceptQuote: "Accettare questo preventivo? Un ordine fornitore verra creato automaticamente.",
    confirmDeclineQuote: "Rifiutare questo preventivo?",
    declineReasonLabel: "Motivo del rifiuto",
    declineReasonPlaceholder: "Si prega di spiegare perché si rifiuta questo preventivo...",
    declineInvoiceReasonPlaceholder: "Si prega di spiegare perché si rifiuta questa fattura...",
    declineReasonRequired: "Un motivo è necessario per rifiutare.",
    recipientDecision: "Decisione del destinatario",
    decisionAccepted: "Accettato dal destinatario",
    decisionDeclined: "Rifiutato dal destinatario",
    decisionDate: "Data della decisione",
    declineReason: "Motivo del rifiuto",
    acceptanceStatus: "Stato di accettazione",
    acceptancePending: "In attesa di accettazione",
    acceptanceNotRequired: "Non richiesto",
    acceptInvoice: "Accetta fattura",
    declineInvoice: "Rifiuta fattura",
    providerInvoiceAccepted: "Fattura accettata",
    providerInvoiceDeclined: "Fattura rifiutata",
    confirmAcceptInvoice: "Accettare questa fattura?",
    confirmDeclineInvoice: "Rifiutare questa fattura?",
    seeProviderOrder: "Vedi ordine fornitore",
    addVouchers: "Aggiungi voucher",
    download: "Scarica",
    file: "File",
    lastModified: "Ultima modifica",
    size: "Dimensione",
    vouchers: "Voucher",
    addFiles: "Aggiungi file",
    attachFiles: "Allega file",
    removeAll: "Rimuovi tutto",
    uploadFiles: "Carica file",
    orders: "Ordini",
    order: "Ordine",
    orderEvaluation: "Valutazione ordine",
    orderGroups: "Gruppi ordine",
    orderNotification: "Notifica ordine",
    orderReference: "Riferimento ordine",
    orderStatus: "Stato ordine",
    addOrder: "Aggiungi ordine",
    approveOrder: "Approva ordine",
    rejectOrder: "Rifiuta ordine",
    cancelOrder: "Annulla ordine",
    companyListOfOrders: "Elenco ordini azienda",
    companyListOfInvoices: "Elenco fatture azienda",
    companyListOfQuotes: "Elenco preventivi azienda",
    companyListOfProviderInvoices: "Elenco fatture fornitore",
    companyListOfProviderOrders: "Elenco ordini fornitore",
    companyListOfProviderQuotes: "Elenco preventivi fornitore",
    companyListOfExpenses: "Elenco spese",
    companyListOfExpenseReports: "Elenco note spese",
    createOrder: "Crea ordine",
    delivery: "Consegna",
    deliveyAddress: "Indirizzo di consegna",
    deliveryNote: "Bolla di consegna",
    deliveryNotes: "Bolle di consegna",
    createDeliveryNote: "Crea bolla di consegna",
    noDeliveryNotesYet: "Nessuna bolla di consegna ancora",
    delivered: "Consegnato",
    notDelivered: "Non consegnato",
    deliveryDate: "Data di consegna",
    deliverAll: "Consegna tutto",
    quantityToDeliver: "Qtà da consegnare",
    quantityOrdered: "Qtà ordinata",
    quantityDelivered: "Qtà consegnata",
    quantityRemaining: "Qtà rimanente",
    alreadyFullyDelivered: "Già completamente consegnato",
    quantityReceived: "Qtà ricevuta",
    quantityToEnter: "Qtà da inserire",
    allItemsReceived: "Tutti gli articoli sono stati ricevuti",
    selectAtLeastOneQuantity: "Selezionare almeno una quantità da inserire",
    sendByEmail: "Invia per email",
    sendToCustomer: "Invia al cliente",
    personalizedMessage: "Messaggio personalizzato",
    deliveryAddressSelection: "Selezione indirizzo di consegna",
    mainAddress: "Indirizzo principale",
    manageAddresses: "Gestisci indirizzi",
    storageCenterSelection: "Selezione centro di stoccaggio",
    autoStockOut: "Uscita automatica dal magazzino",
    quantityInStock: "Quantità in magazzino",
    stockAvailability: "Disponibilità in magazzino",
    stockWarnings: "Avvisi di magazzino",
    deliveryProgress: "Progresso della consegna",
    deliveryComplete: "Consegna completa",
    deliveryPartial: "Consegna parziale",
    notDeliveredYet: "Non ancora consegnato",
    deliveryAddressLabel: "Indirizzo di consegna",
    sentAt: "Inviato il",
    sentMethod: "Metodo di invio",
    backToOrder: "Torna all'ordine",
    linesDelivered: "Righe consegnate",
    createInvoiceFromSelection: "Crea fattura dalla selezione",
    ordersWillBeInvoicedTogether: "ordine/i saranno fatturati insieme",
    ordersSelected: "ordine/i selezionato/i",
    editOrder: "Modifica ordine",
    exportOrder: "Esporta ordine",
    exportOrders: "Esporta ordini",
    generateInvoice: "Genera fattura",
    generateOrder: "Genera ordine",
    listOrders: "Elenco ordini",
    orderDate: "Data ordine",
    orderFile: "File ordine",
    orderNumber: "Numero ordine",
    selectExportType: "Seleziona tipo di esportazione",
    sendOrder: "Invia ordine",
    thisOptionIsUniqueAndNewInvoice: "Questa opzione è unica e non può essere creata una nuova fattura da questo ordine",
    updateOrder: "Aggiorna ordine",
    viewOrder: "Visualizza ordine",
    invoice: "Fattura",
    invoices: "Fatture",
    addInvoice: "Aggiungi fattura",
    amountDebt: "Importo debito",
    amountPaid: "Importo pagato",
    companyInvoiceList: "Elenco fatture azienda",
    createInvoice: "Crea fattura",
    editInvoice: "Modifica fattura",
    exportInvoices: "Esporta fatture",
    exportProviderInvoices: "Esporta fatture fornitore",
    exportProviderOrders: "Esporta ordini fornitore",
    exportProviderQuotes: "Esporta preventivi fornitore",
    exportExpenses: "Esporta spese",
    exportExpenseReports: "Esporta note spese",
    debt: "Debito",
    fullyPaid: "Completamente pagato",
    invalidInvoices: "Fatture non valide",
    invalidateInvoice: "Annulla fattura",
    invalidateProviderOrder: "Invalidare l'ordine del fornitore",
    validateProviderOrder: "Convalida l'ordine del fornitore",
    invoiceGroups: "Gruppi fattura",
    invoiceDate: "Data fattura",
    invoiceNumber: "Numero fattura",
    invoiceStatus: "Stato fattura",
    invoiceValidity: "Validità fattura",
    listInvoices: "Elenco fatture",
    notPayed: "Non pagata",
    partiallyPaid: "Parzialmente pagata",
    payed: "Pagata",
    thisInvoiceHasNoPayments: "Questa fattura non ha pagamenti",
    updateInvoice: "Aggiorna fattura",
    validated: "Convalidata",
    validateInvoice: "Convalida fattura",
    viewInvoice: "Visualizza fattura",
    youWillBeAbleToUndoThisAction: "Sarai in grado di annullare questa azione",
    payment: "Pagamento",
    payments: "Pagamenti",
    amountToPay: "Importo da pagare",
    createNewPayment: "Crea nuovo pagamento",
    deleteSomePayment: "Elimina qualche pagamento",
    doNotDeletePayments: "Non eliminare alcun pagamento",
    makePayment: "Effettua pagamento",
    method: "Metodo",
    paymentDate: "Data pagamento",
    paymentMethod: "Metodo di pagamento",
    save: "Salva",
    sourceOfIncome: "Fonte di entrata",
    accountingAccountProductService: "Conto contabile del prodotto o servizio",
    sourceTheAmount: "Fonte da cui viene depositato o prelevato l'importo della transazione",
    sourceTheAmountEntered: "Fonte in cui viene inserito l'importo della transazione",
    sourceTheAmountWithdrawn: "Fonte da cui viene prelevato l'importo della transazione",
    cash: "Contanti",
    card: "Carta",
    payPal: "PayPal",
    transfer: "Bonifico",
    mobile: "Mobile",
    thisOptionIncludeTaxPrice: "Questa opzione include le tasse nel prezzo indicato",
    thisOptionNotIncludeTaxPrice: "Questa opzione non include le tasse nel prezzo indicato",
    addOrRemoveContactCompanies: "Aggiungi o rimuovi aziende contatto",
    notifyMe: "Notificami",
    background: "Sfondo",
    inventory: "Inventario",
    viewProduct: "Visualizza prodotto",
    storageCenter: "Centro di stoccaggio",
    listStorageCenter: "Elenco dei centri di stoccaggio",
    viewStorageCenter: "Vista del centro di stoccaggio",
    afterSalesService: "Servizio post-vendita",
    bookingJournals: "Registri contabili",
    appLanguage: "Lingua dell'app",
    theUuidCanBeUsedToCreateNnewContact: "L'UUID può essere usato per creare un nuovo contatto",
    settingInformation: "Informazioni di impostazione",
    addOrRemoveCompanies: "Aggiungi/Rimuovi aziende",
    notGrouped: "Non raggruppato",
    notFiltered: "Non filtrato",
    orderValidity: "Validità ordine",
    expiration: "Scadenza",
    quoteExpiration: "Scadenza preventivo",
    orderExpiration: "Scadenza ordine",
    invoiceExpiration: "Scadenza fattura",
    discountTotal: "Sconto totale",
    addService: "Aggiungi servizio",
    addProduct: "Aggiungi prodotto",
    noRecords: "Nessun record",
    quantityMinimumForRebate: "Quantità minima per sconto",
    nonExistentRebateNegativePrice: "Sconto inesistente per prezzo negativo",
    thisOptionRebateIsFixedAmount: "Questa opzione indica che lo sconto è un importo fisso",
    thisOptionRebateIsPercentage: "Questa opzione indica che lo sconto è una percentuale",
    thisOptionRebateIsNone: "Questa opzione indica che non c'è sconto",
    totalAfterRebates: "Totale dopo sconti",
    calculator: "Calcolatrice",
    enterRebate: "Inserisci lo sconto",
    reference: "Riferimento",
    newOrder: "Nuovo ordine",
    invoiceReference: "Riferimento fattura",
    newInvoice: "Nuova fattura",
    providerOrderValidity: "Validità ordine fornitore",
    expenseStatus: "Stato spesa",
    newProviderOrder: "Nuovo ordine fornitore",
    newProviderInvoice: "Nuova fattura fornitore",
    newExpense: "Nuova spesa",
    viewVoucher: "Visualizza voucher",
    informationAdditional: "Informazioni aggiuntive",
    no: "No",
    bank: "Banca",
    fullNameBankAccountHolder: "Nome completo del titolare del conto bancario",
    bankAccountHolder: "Titolare del conto bancario",
    isNecessaryToHaveReferenceToActivateOption: "È necessario avere un riferimento per attivare questa opzione",
    isNecessaryToHaveAtLeastTwoTreasuryAccountsToActivateOption:
      "È necessario avere almeno due conti di tesoreria per attivare questa opzione",
    none: "Nessuno",
    undefined: "Non definito",
    colorCombinationForDesignOfDocumentToDownload: "Combinazione di colori per il design del documento da scaricare",
    all: "Tutti",
    lettersTitlesSubtitles: "Lettere, titoli, sottotitoli",
    firstBar: "Prima barra",
    secondBar: "Seconda barra",
    barLetters: "Lettere barra",
    qrIbanAndQrReference: "QR-IBAN e QR-Riferimento",
    ibanAndStructuredCreditorReference: "IBAN e Riferimento Creditore Strutturato (SCOR)",
    ibanWithoutReference: "IBAN senza riferimento",
    cashAccount: "Conto in contanti",
    postalAccount: "Conto postale",
    bankAccount: "Conto bancario",
    currentAccount: "Conto corrente soci",
    listProducts: "Elenco prodotti",
    category: "Categoria",
    categories: "Categorie",
    listCategories: "Elenco categorie",
    tags: "Tag",
    variants: "Varianti",
    photography: "Fotografia",
    reminder: "Promemoria",
    reminders: "Promemoria",
    paymentStatus: "Stato pagamento",
    year: "Anno",
    createReminder: "Crea promemoria",
    updateReminder: "Aggiorna promemoria",
    makeCopy: "Fai copia",
    reminderTotal: "Totale promemoria",
    inDispute: "In disputa",
    addCategory: "Aggiungi categoria",
    addStorageCenter: "Aggiungi centro di archiviazione",
    addBookingJournal: "Aggiungi registro contabile",
    qtyAssets: "Q.tà beni",
    qtyServices: "Q.tà servizi",
    qtyProducts: "Q.tà prodotti",
    viewCategory: "Visualizza categoria",
    editCategory: "Modifica categoria",
    deleteCategory: "Elimina categoria",
    names: "Nomi",
    listCategoryItems: "Elenco elementi categoria",
    editListing: "Modifica elenco",
    updateCategoryItemList: "Aggiorna elenco elementi categoria",
    updateCategory: "Aggiorna categoria",
    nameInOtherLanguages: "Nome in altre lingue",
    enterInLanguageWant: "Inserisci nella lingua desiderata",
    enterNameOfRequestedLanguages: "Inserisci il nome delle lingue richieste",
    enterDesiredValuePressEnterAdd: "Inserisci il valore desiderato e premi Invio per aggiungerlo",
    enterOrModifyInLanguage: "Inserisci o modifica nella lingua desiderata",
    general: "Generale",
    categoryName: "Nome categoria",
    categoryType: "Tipo di categoria",
    createCategory: "Crea categoria",
    editProduct: "Modifica prodotto",
    deleteProduct: "Elimina prodotto",
    productReferencePictures: "Immagini di riferimento prodotto",
    code: "Codice",
    sku: "SKU",
    codebar: "Codice a barre",
    color: "Colore",
    unit: "Unità",
    price: "Prezzo",
    priceSale: "Prezzo di vendita",
    pricePurchase: "Prezzo di acquisto",
    fixed: "Fisso",
    productName: "Nome prodotto",
    productDetails: "Dettagli prodotto",
    advanced: "Avanzato",
    addVariant: "Aggiungi variante",
    uniqueProductCodeAssignedByCompany: "Codice prodotto univoco assegnato dall'azienda",
    additionalCommentDescriptionProductVariant: "Commento aggiuntivo o descrizione per la variante del prodotto",
    selectDiscountTypeAppliedToProduct: "Seleziona un tipo di sconto da applicare a questo prodotto",
    discountType: "Tipo di sconto",
    selectDiscountTypeThatWillAppliedProduct: "Seleziona il tipo di sconto da applicare a questo prodotto",
    noDiscount: "Nessuno sconto",
    setDiscountPercentage: "Imposta percentuale sconto",
    fixedDiscountedAmount: "Importo sconto fisso",
    quantityMinimumDiscount: "Quantità minima per sconto",
    createProduct: "Crea prodotto",
    dropFilesHereOrClickUpload: "Trascina i file qui o clicca per caricare",
    dropFileHereOrClickUpload: "Trascina il file qui o clicca per caricare",
    uploadUpToFiles: "Carica fino a 10 file",
    success: "Successo",
    addNewProductVariant: "Aggiungi nuova variante prodotto",
    editVariant: "Modifica variante",
    editProductVariant: "Modifica variante prodotto",
    updateProduct: "Aggiorna prodotto",
    saveVariant: "Salva variante",
    listServices: "Elenco servizi",
    viewService: "Visualizza servizio",
    editService: "Modifica servizio",
    deleteService: "Elimina servizio",
    serviceReferencePictures: "Immagini di riferimento servizio",
    serviceName: "Nome servizio",
    serviceDetails: "Dettagli servizio",
    createService: "Crea servizio",
    updateService: "Aggiorna servizio",
    uniqueServiceCodeAssignedByCompany: "Codice servizio univoco assegnato dall'azienda",
    selectDiscountTypeAppliedToService: "Seleziona un tipo di sconto da applicare a questo servizio",
    expenseAccount: "Conto spesa",
    vatAccount: "Conto IVA",
    accountProduct: "Conto prodotto",
    accountingAccount: "Conto contabile",
    accountingAccounts: "Conti contabili",
    accountingAccountPurchases: "Conto contabile acquisti",
    accountingAccountSales: "Conto contabile vendite",
    addAccountingAccount: "Aggiungi conto contabile",
    rangeAllowedCodes: "Intervallo codici consentiti",
    effective: "Conteggio effettivo",
    tdfn: "DAliquota del debito fiscale netto (TDFN)",
    taf: "Aliquota forfettaria (TaF)",
    vatAccountingType: "Tipo di conteggio IVA",
    theVatRegimeCanOnlyChangedOnceAYear:
      "Il regime IVA può essere modificato una sola volta all'anno, appena prima di iniziare un nuovo esercizio contabile",
    debit: "Dare",
    credit: "Avere",
    customerReceivable: "Crediti verso clienti",
    providerReceivable: "Crediti verso fornitori",
    vatDue: "IVA dovuta",
    vatRecoverable: "IVA detraibile",
    declarationMethod: "Metodo di dichiarazione",
    onInvoicing: "In base alla fatturazione (alla fatturazione)",
    onCashing: "In base agli incassi (all’incasso)",
    valid: "Valido",
    invalid: "Non valido",
    colorIsInvalid: "Colore non valido",
    theValueIsNotAValid: "Il valore non è valido",
    theValueIsNotAValidUUIDOrNameUser: "Il valore non è un UUID o un nome utente valido",
    theValueIsAtLeast8Digits: "Il valore ha almeno 8 cifre",
    theValueDoesNotMatch: "Il valore non corrisponde",
    theValueAlreadyExists: "Il valore esiste già",
    limitFilesMaximum: "Limite massimo di 10 file",
    required: "Obbligatorio",
    theValueIsRequired: "Il valore è obbligatorio",
    allValuesRequired: "Tutti i valori sono obbligatori",
    colorIsRequired: "Il colore è obbligatorio",
    requirementsIsRequired: "I blocchi sono obbligatori",
    paymentsIsRequired: "I pagamenti sono richiesti",
    contentsToRequirementIsRequired: "Il contenuto del blocco è obbligatorio",
    transaction: "Transazione",
    createNewPaymentForInvoice: "Crea nuovo pagamento per fattura",
    createNewPaymentForProviderInvoice: "Crea nuovo pagamento per fattura fornitore",
    addTransaction: "Aggiungi transazione",
    accountingEntry: "Scrittura contabile",
    amountAvailable: "Importo disponibile",
    selectExistingTransaction: "Seleziona transazione esistente",
    totalAmountDebt: "Debito totale",
    presetCurrency: "Valuta preimpostata",
    deposit: "Deposito",
    deposition: "Deposizione",
    depositAmount: "Importo deposito",
    pastTransactions: "Transazioni passate",
    noPastTransactions: "Nessuna transazione passata",
    selectTransaction: "Seleziona una transazione",
    providerInvoice: "Fattura fornitore",
    expense: "Spesa",
    enterNewTransaction: "Inserisci nuova transazione",
    useExistingTransaction: "Usa una transazione esistente",
    transactionToRecordPayment: "Transazione per registrare il pagamento",
    amountMoneyEnteredInTransaction: "Importo inserito nella transazione",
    amountMoneyWithdrawnInTransaction: "Importo prelevato nella transazione",
    identifiedTransactions: "Transazioni identificate",
    unidentifiedTransactions: "Transazioni non identificate",
    totalDepositAmount: "Importo totale deposito",
    makeCorrespondingPayment: "Effettua il pagamento corrispondente",
    balance: "Saldo",
    accountingEntries: "Scritture contabili",
    contactBalance: "Saldo contatto",
    accountStatement: "Estratto conto",
    accountStatements: "Estratti conto",
    invoiceIssuance: "Emissione fattura",
    saleIssuance: "Emissione della vendita",
    providerInvoiceIssuance: "Emissione fattura fornitore",
    expenseIssuance: "Emissione spesa",
    allocationInvoiceReminder: "Allocazione per promemoria fattura",
    transactionToPostFinance: "Transazione conto PostFinance",
    transactionFormPostFinance: "Transazione conto PostFinance",
    balancePrevious: "Saldo precedente",
    includeOpeningBalance: "Includere il saldo di apertura",
    balanceFavorContact: "Saldo a favore del contatto",
    balanceFavorCompany: "Saldo a nostro favore",
    addCredit: "Aggiungi credito",
    addDebit: "Aggiungi debito",
    createClientCredit: "Nuova scrittura in avere",
    createClientDebit: "Nuova scrittura in dare",
    unidentifiedTransactionToRegisterInContact: "Transazione non identificata da registrare nel contatto",
    draft: "Bozza",
    revertToDraft: "Ritorna a bozza",
    beforeCreatingProviderInvoice: "Prima di creare una fattura fornitore",
    beforeCreatingProviderOrder: "Prima di creare un ordine fornitore",
    beforeCreatingExpense: "Prima di creare una spesa",
    viewPdf: "Visualizza PDF",
    viewOriginalPdf: "Visualizza PDF originale",
    documentPdf: "PDF del documento",
    viewReferencePdf: "Visualizza PDF di riferimento",
    referencePdf: "PDF di riferimento",
    invalidFileType: "File in formato diverso",
    fileInDifferentFormatImg: "File in formato diverso. Tipi di file consentiti: jpeg, jpg o png",
    fileSizeNotAllowed: "File troppo grande. Dimensione massima: 1 MB",
    fileInDifferentFormatPdf: "File in formato diverso. Formato file: pdf",
    fileIsTooBig: "Il file è troppo grande. Dimensione massima: 10 MB",
    addDocument: "Aggiungi documento",
    validate: "Valida",
    invalidate: "Invalidare",
    listing: "Elenco",
    creation: "Creazione",
    accounting: "Contabilità",
    generalLedger: "Libro mastro",
    bookingJournal: "Giornale contabile",
    label: "Etichetta",
    multipleWriting: "Scrittura multipla",
    simplifiedMultipleWriting: "Scrittura multipla semplificata",
    availableAmount: "Importo disponibile",
    level: "Livello",
    coefficient: "Coefficiente",
    leave: "Congedo",
    title: "Titolo",
    writingSimple: "Scrittura semplice",
    writingMultiple: "Scrittura multipla",
    writingSimplifiedMultiple: "Scrittura multipla semplificata",
    taxIncluded: "Con IVA",
    taxExcluded: "Senza IVA",
    taxFee: "Imposta (IVA)",
    vatOptions: "Opzioni IVA",
    interest: "Interesse",
    penalty: "Penale",
    refund: "Rimborso",
    creditNote: "Nota di credito",
    customerInterest: "Interesse cliente",
    customerPenalty: "Penale cliente",
    customerRefund: "Rimborso cliente emesso",
    providerPayment: "Pagamento fornitore emesso",
    providerCreditNote: "Nota di credito fornitore emessa",
    providerInterest: "Interesse fornitore",
    providerPenalty: "Penale fornitore",
    providerRefund: "Rimborso fornitore emesso",
    customerPayment: "Pagamento ricevuto da un cliente",
    customerCreditNote: "Nota di credito cliente emessa",
    transactionType: "Tipo di transazione",
    resend: "Inviare di nuovo",
    information: "Informazioni",
    generalInformation: "Informazioni generali",
    vatCalculationPeriod: "Periodo di calcolo dell'IVA",
    dependsWhetherCompanySubjectTax: "Dipende se l'azienda è soggetta a tassazione",
    dependsCompanySpecialVatRegime: "Dipende dal regime IVA speciale dell'azienda",
    dependsCompanyVatCalculationPeriod: "Dipende dal periodo di calcolo dell'IVA dell'azienda",
    upcomingVatStatement: "Prossima dichiarazione IVA",
    deadline: "Scadenza",
    quarter: "Trimestre",
    semester: "Semestre",
    chartAccounts: "Piano dei conti",
    vatStatement: "Dichiarazione IVA",
    listVatStatements: "Elenco dichiarazioni IVA",
    manual: "Manuale",
    vatSettingsMap: "Mappa delle impostazioni IVA",
    listPeriodsStatement: "Elenco dei periodi per la dichiarazione IVA",
    vatAmount: "IVA",
    vatAmountDue: "Importo IVA dovuto",
    regime: "Regime",
    calculation: "Calcolo",
    tickets: "Biglietti",
    pendingVatTickets: "Ticket IVA in sospeso",
    orphansOnly: "Solo orfani",
    formLine: "Riga modulo",
    vatShort: "IVA",
    side: "Lato",
    accrual: "Accantonamento",
    open: "Aperto",
    filed: "Archiviato",
    closed: "Chiuso",
    listPeriodStatement: "Elenco dei periodi di riferimento",
    exportStatementPeriod: "Esportazione del periodo di riferimento",
    editAccountingSettings: "Modifica impostazioni contabili",
    brand: "Marca",
    features: "Caratteristiche",
    createStorageCenter: "Crea centro di archiviazione",
    updateStorageCenter: "Aggiorna centro di archiviazione",
    editStorageCenter: "Modifica centro di archiviazione",
    addInventory: "Aggiungi all'inventario",
    storagePurchase: "Deposito per l'acquisto",
    operations: "Operazioni",
    storageOperations: "Operazioni di stoccaggio",
    listOperationsStorageCenter: "Elenco delle operazioni di un centro di stoccaggio",
    sourceLocation: "Posizione di origine",
    destinationLocation: "Posizione di destinazione",
    source: "Fonte",
    invalidated: "Invalidato",
    in: "Dentro",
    out: "Fuori",
    adjustment: "Regolazione",
    stockEntry: "Entrata di magazzino",
    stockExit: "Uscita di magazzino",
    stockTransfer: "Trasferimento di magazzino",
    sourceStorageCenter: "Centro di uscita",
    destinationStorageCenter: "Centro di entrata",
    availableStock: "Stock disponibile",
    quantityToTransfer: "Quantità da trasferire",
    addLine: "Aggiungi una riga",
    selectProduct: "Seleziona un prodotto",
    removeLine: "Rimuovi",
    providerOrder: "Ordine del fornitore",
    updatePos: "Aggiorna POS",
    pos: "POS",
    listPOS: "Elenco POS",
    createPOS: "Crea POS",
    createNewPOS: "Crea un nuovo POS",
    viewPOS: "Visualizza POS",
    createSale: "Crea vendita",
    pointOfSale: "Punto vendita",
    selectProducts: "Seleziona prodotti",
    selectedItems: "Articoli selezionati",
    noItemsSelected: "Nessun articolo selezionato",
    step1: "Passo 1",
    step2: "Passo 2",
    paymentMethods: "Metodi di pagamento",
    received: "Ricevuto",
    totalPaid: "Totale pagato",
    totalCash: "Totale contanti",
    totalCard: "Totale carta",
    paymentCalculation: "Calcolo del pagamento",
    completeSale: "Completa vendita",
    listOfSales: "Elenco vendite",
    noTransactionsToday: "Nessuna transazione oggi",
    totalTransactions: "Totale transazioni",
    active: "Attivo",
    inactive: "Inattivo",
    startCreatingNewPOSForYourCompany: "Inizia creando nuovi POS per la tua azienda",
    add: "Aggiungi",
    change: "Resto",
    cashier: "Cassiere",
    saleNumber: "Numero di vendita",
    viewSale: "Visualizza la vendita",
    return: "Ritorno",
    createNewSale: "Crea una nuova vendita",
    defaultCustomerSale: "Cliente predefinito di una vendita",
    heWantsAccessApplicationLink: "Vuole accedere all'applicazione tramite un link",
    security: "Sicurezza",
    signOutAllDevices: "Disconnettiti da tutti i dispositivi",
    editDeadlinePaymentParameter: "Modifica parametro scadenza pagamento",
    editFeatureParameter: "Modifica parametro caratteristica",
    editMeasureUnitParameter: "Modifica parametro unità di misura",
    addMeasureUnitParameter: "Aggiungi parametro unità di misura",
    areYouSureYouWantToDeleteThisRecord: "Sei sicuro di voler eliminare questo record?",
    youWontBeAbleToRevertThis: "Non potrai annullare questa azione",
    yesDeleteIt: "Sì, elimina",
    confirmPurchase: "Conferma acquisto",
    confirmPurchaseDesignMessage: "Vuoi confermare l'acquisto di questo design?",
    yesPurchase: "Sì, acquista",
    companyColorSettings: "Impostazioni colori aziendali",
    saveColors: "Salva colori",
    companyDesignSettings: "Impostazioni design aziendale",
    currentDesign: "Design attuale",
    setAsCurrent: "Imposta come attuale",
    subjectToVat: "Soggetto a IVA",
    companySwitchingNotAvailableInView:
      "Il cambio di azienda non è disponibile in questa vista; può essere effettuato solo dalle viste generali dell'azienda",

    // Start sentence
    selectOneOption: "Seleziona una delle opzioni,",
    iAgree: "Accetto &",
    youWantToChangeOrderStatusTo: "Vuoi cambiare lo stato dell'ordine in",
    createdAt: "Creato il",
    updatedAt: "Aggiornato il",
    validUntil: "Valido fino a",
    clickOn: "Clicca su",
    thisContactWillOnlyBeRegisteredInCompany: "Questo contatto sarà registrato solo nell'azienda",
    securedPaymentBy: "Pagamento sicuro tramite",
    anInvitationWillBeSent: "Verrà inviata un’invito per accedere all’azienda",
    ifYouNeedMoreInfo: "Se hai bisogno di ulteriori informazioni, controlla su",
    theInvitationToAccess: "L'invito ad accedere all'azienda da parte dell'utente",
    theQuoteThatYouSent: "Il preventivo che hai inviato all'azienda",
    youHaveAlreadyEvaluatedOrder: "Hai già valutato l'ordine dell'azienda",
    youHaveAlreadyEvaluatedQuote: "Hai già valutato il preventivo dell'azienda",
    youHaveAlreadyRespondedTo: "Hai già risposto a",
    youHaveReceivedAQuote: "Hai ricevuto un preventivo dall'azienda",
    ifYouDoNotWishToExtendContactModificationsToOtherCompanies:
      "Se non desideri estendere le modifiche dei contatti ad altre aziende, non selezionare nulla e scegli",
    youWantToChangeQuoteStatusTo: "Vuoi cambiare lo stato del preventivo in",
    youWantToChangeProviderOrderStatusTo: "Vuoi cambiare lo stato dell'ordine fornitore in",
    theOrderThatYouSent: "L'ordine che hai inviato all'azienda",
    youHaveReceivedAnOrder: "Hai ricevuto un ordine dall'azienda",
    theCurrentCompanyIs: "L'azienda corrente è",
    toCreateA: "Per creare un",
    createdBy: "Creato da",
    groupBy: "Raggruppa per",
    checkOrUncheck: "Seleziona o deseleziona il",
    ifYouWishChangeVatRegimePleaseContact: "Se desideri cambiare il regime IVA, devi contattare",
    ifYouInvalidateInvoice: "Se invalidi la fattura",
    ifYouInvalidateProviderOrder: "Se invalida l'ordine del fornitore",
    ifYouInvalidateProvaiderInvoice: "Se invalidi la fattura fornitore",
    ifYouInvalidateExpense: "Se invalidi la spesa",
    the: "Il",
    planYourBusinessApplications: "Pianifica le tue applicazioni aziendali scegliendo una delle",
    yourAccountIsNotVerified:
      "Il tuo account non è verificato. Convalida il tuo account tramite il tuo indirizzo email cliccando sul pulsante",
    chargeFor: "Addebito per",
    serverErrorOccurred: "Si è verificato un errore del server",
    noResponseServer: "Nessuna risposta ricevuta dal server",
    serviceTemporarilyUnavailable: "Il servizio è temporaneamente non disponibile. Si prega di riprovare.",
    records: "Registri",
    invitations: "Inviti",
    consignment: "Conto deposito",
    consignmentReturn: "Reso conto deposito",
    consignments: "Conti deposito",
    listConsignments: "Elenco conti deposito",
    commissionType: "Tipo di commissione",
    commissionRate: "Tasso di commissione",
    newConsignment: "Nuovo accordo",
    receiveProducts: "Ricevere prodotti",
    returnProducts: "Restituire invenduti",
    generateReport: "Generare rapporto",
    quantitySold: "Qtà venduta",
    quantityReturned: "Qtà restituita",
    quantityAvailable: "Qtà disponibile",
    quantityToReturn: "Qtà da restituire",
    totalSoldValue: "Valore totale venduto",
    commissionAmount: "Importo commissione",
    amountDueToProvider: "Importo dovuto al fornitore",
    closeAgreement: "Chiudere l'accordo",
    consignmentAgreement: "Accordo di consegna",
    fixedPrice: "Prezzo fisso",
    documents: "Documenti",
    document: "Documento",
    listDocuments: "Elenco documenti",
    uploadDocument: "Carica documento",
    assignDocument: "Assegna documento",
    archiveDocument: "Archivia documento",
    unarchiveDocument: "Rimuovi da archivio",
    ignoreDocument: "Ignora documento",
    unignoreDocument: "Ripristina documento",
    inbox: "Casella di ricezione",
    archives: "Archivio",
    youWantToIgnoreThisDocument: "Vuoi davvero ignorare questo documento?",
    youWantToUnignoreThisDocument: "Vuoi davvero ripristinare questo documento?",
    youWantToArchiveThisDocument: "Vuoi davvero archiviare questo documento?",
    youWantToUnarchiveThisDocument: "Vuoi davvero rimuovere questo documento dall'archivio?",
    successfullyIgnored: "Documento ignorato con successo",
    successfullyUnignored: "Documento ripristinato con successo",
    successfullyArchived: "Documento archiviato con successo",
    successfullyUnarchived: "Documento rimosso dall'archivio con successo",
    cannotIgnoreDocument: "Impossibile ignorare il documento",
    cannotIgnoreDocumentWithAssignments: "Questo documento ha assegnazioni attive. Rimuoverle prima di ignorarlo.",
    deleteDocument: "Elimina documento",
    fileName: "Nome file",
    assignedTo: "Assegnato a",
    assigned: "Assegnato",
    preview: "Anteprima",
    downloadFile: "Scarica file",
    upload: "Carica",
    assign: "Assegna",
    documentType: "Tipo di documento",
    documentReference: "Riferimento documento",
    enterDocumentReference: "Inserisci riferimento documento",
    partiallyProcessed: "Parzialmente elaborato",
    processed: "Elaborato",
    originalFile: "File originale",
    documentDate: "Data documento",
    uploadedOn: "Caricato il",
    documentDetails: "Dettagli documento",
    documentName: "Nome documento",
    previewNotAvailable: "Anteprima non disponibile",
    documentUpdated: "Documento aggiornato",
    createFromDocument: "Crea da documento",
    attachExistingDocument: "Allega documento esistente",
    selectDocumentToAttach: "Seleziona un documento da allegare",
    documentAttached: "Documento allegato con successo",
    noDocumentsAvailable: "Nessun documento disponibile",
    attach: "Allega",
    uploadNewPdf: "Carica nuovo PDF",
    removeDocument: "Rimuovi",
    confirmRemoveVoucher: "Rimuovere questo documento?",
    brands: "Marchi",
    youWantToDeleteThisBrand: "Vuoi eliminare questo marchio?",
    listBrands: "Elenco marchi",
    createBrand: "Crea marchio",
    searchBrand: "Cerca marchio",
    clear: "Cancella",
    sortBy: "Ordina per",
    show: "Mostra",
    perPage: "per pagina",
    showing: "Visualizzazione",
    of: "di",
    nameRequired: "Nome richiesto",
    nameIsRequired: "Il nome è obbligatorio",
    updateBrand: "Aggiorna marchio",
    enterBrandName: "Inserisci il nome del marchio",
    logoUrlHint: "Inserisci l'URL del logo",
    processing: "Elaborazione in corso",
    editBrand: "Modifica marchio",
    logoUrl: "URL del logo",
    addBrand: "Aggiungi marchio",
    selectBrand: "Seleziona marchio",
    noBrandsAvailable: "Nessun marchio disponibile",

    // End sentence
    companyPleaseEvaluateQuote: ", per favore valuta il preventivo.",
    theAssociatedAccountingEntriesWillBeDeletedInvoice:
      ", le registrazioni contabili associate saranno eliminate. Questo significa che non potrai effettuare pagamenti o generare solleciti relativi a questa fattura.",
    theAssociatedAccountingEntriesWillBeDeletedProviderInvoice:
      ", le registrazioni contabili associate saranno eliminate. Questo significa che non potrai effettuare pagamenti o generare solleciti relativi a questa fattura fornitore.",
    theAssociatedAccountingEntriesWillBeDeletedExpense:
      ", le registrazioni contabili associate saranno eliminate. Questo significa che non potrai effettuare pagamenti o generare solleciti relativi a questa spesa.",
    theAssociatedProductsWillBeRemoved:
      ", i prodotti associati verranno rimossi. Ciò significa che non verranno registrati nell'inventario dei centri di stoccaggio relativi a quell'ordine fornitore.",
    ifYouWishToSaveTheChangesMade: "se desideri salvare le modifiche apportate.",
    youWantToRun: "che desideri eseguire.",
    toContinue: "per continuare.",
    waitAMomentToVerifyYourAccess: "attendi un momento per verificare il tuo accesso.",
    hasSentARequestForAccessToTheFollowingCompany: "ha inviato una richiesta di accesso alla seguente azienda, per favore rispondi.",
    ifYouWantToSaveTheNewQuote: "se desideri salvare il nuovo preventivo.",
    ifYouWantToSaveTheNewQuoteWithTheChangesMade: "se desideri salvare il nuovo preventivo con le modifiche apportate.",
    ifYouWantToSaveTheNewInvoiceWithTheChangesMade: "se desideri salvare la nuova fattura con le modifiche apportate.",
    ifYouWantToSaveTheNewExpense: "se desideri salvare la nuova spesa.",
    ifYouWantToSaveTheNewProviderInvoice: "se desideri salvare la nuova fattura fornitore.",
    ifYouWantToSaveTheNewProviderOrder: "se desideri salvare il nuovo ordine fornitore.",
    ifYouWantToSaveTheNewProviderOrderWithTheChangesMade: "se desideri salvare il nuovo ordine fornitore con le modifiche apportate.",
    ifYouWantToSaveTheNewProviderInvoiceWithTheChangesMade: "se desideri salvare la nuova fattura fornitore con le modifiche apportate.",
    ifYouWantToSaveTheNewOrder: "se desideri salvare il nuovo ordine.",
    ifYouWantToSaveTheNewOrderWithTheChangesMade: "se desideri salvare il nuovo ordine con le modifiche apportate.",
    companyPleaseEvaluateTheOrder: "azienda, per favore valuta l'ordine.",
    ifYouWantToSaveTheNewInvoice: "se desideri salvare la nuova fattura.",
    youWillNotBeAbleToRemoveItFromThisCompany: ", non potrai rimuoverlo da questa azienda, ma puoi selezionare le altre aziende.",
    inThisCategory: "in questa categoria.",
    theCompanyContainTreasutyAccount: "l'azienda deve contenere almeno un conto di tesoreria.",
    toBeAddedInOrderToDownloadTheInvoice: "deve essere aggiunto per scaricare la fattura.",

    // All sentence
    enterNewPassword: "Inserisci una nuova password.",
    ifYouChangeYourMind: "Se cambi idea, richiedi l'invio di una nuova applicazione.",
    messageWillBeSentYourEmailToRecoverAccount:
      "Un messaggio verrà inviato alla tua email per recuperare l'account, controlla la tua posta. Sarai reindirizzato alla pagina di login.",
    yuouCanNowStartUsingApp: "Ora puoi iniziare a utilizzare l'app, verrai reindirizzato alla home page a breve.",
    newCompanyIsSelectedByDefault: "La nuova azienda è selezionata di default e verrai reindirizzato alla pagina principale.",
    notificationWillBeDeleted: "La notifica dell'invito ad accedere all'azienda verrà eliminata.",
    theAppWillBeTranslated:
      "L'applicazione verrà tradotta nella lingua selezionata, ad eccezione delle informazioni inserite nei documenti.",
    userWillRespondInvitation: "L'utente risponderà se accetta o rifiuta l'invito ad accedere all'azienda.",
    youWillNotBeAbleToUndo: "Non potrai annullare questa azione.",
    toValidateYourAccount: "Per convalidare il tuo account, verrà inviato un messaggio al tuo indirizzo e-mail dove potrai verificarlo.",
    pleaseCheckEmailToValidateAccount: "Controlla la tua e-mail, ti abbiamo inviato un messaggio per convalidare il tuo account.",
    anEmailSentToValidateAccount: "Ti è stata inviata un'e-mail per convalidare il tuo account.",
    validatedAccountForLoggedInUser: "Account convalidato per l'utente connesso, reindirizzando alla pagina principale.",
    validatedAccountForADifferentUser:
      "Account convalidato per un utente diverso da quello attualmente connesso, reindirizzando alla pagina di login.",
    validatedVerifiedForAUserWhoHasNotLoggedIn:
      "Convalidato e verificato per un utente che non ha effettuato il login, reindirizzando alla pagina di login.",
    newServicesWithinTheSameApp: "Nuovi servizi all'interno della stessa applicazione.",
    soonYouWillBeAbleToAccessNewFunctionalities: "Presto potrai accedere a nuove funzionalità all'interno dell'applicazione.",
    pleaseCorrectThePathOfThePageInOrderToAccess: "Correggi il percorso della pagina per accedere all'applicazione.",
    pleaseTryAgainLater: "Per favore riprova più tardi.",
    validTokenAutomaticLoginRedirectedDashboard: "Token valido, accesso automatico, reindirizzamento alla pagina della dashboard.",
    redirectingToLogin: "Reindirizzamento alla pagina di login.",
    willNotBeAbleToReturnUntilYouLogin: "Non potrai tornare indietro fino a quando non effettuerai nuovamente il login.",
    enterEmailWhetherBelongsRegisteredUserOrNot:
      "Inserisci l’indirizzo email, che appartenga o meno a un utente registrato. Verrà inviata una notifica per accedere all’applicazione e all’azienda, sia all’interno dell’applicazione (se l’utente esiste) sia all’indirizzo email fornito.",
    theFileMustBeFormat: "Il file deve essere in formato jpeg, jpg o png.",
    ifYouHaveAnyQuestionsContactUs: "Se hai domande, puoi contattarci.",
    noNotificationsSeenYet: "Non sono ancora state viste notifiche.",
    thereAreNoNotifications: "Non sono ancora state ricevute notifiche.",
    invitationsHaveNotReceived: "Gli inviti non sono ancora pervenuti.",
    byDefaultValuesOfTheCompanyAreTaken: "Di default vengono presi i valori dell'azienda.",
    selectTheOptionsThatBestConsiderWhenDownloading:
      "Seleziona le opzioni che ritieni migliori quando scarichi un preventivo o una fattura in formato PDF.",
    notificationsAboutInvitationsToSubscribe: "Notifiche relative agli inviti ad iscriversi e ottenere accesso a un'azienda.",
    whenCreatingAContactByUUID:
      "Quando crei un contatto tramite UUID, non potrai modificare determinati campi a seconda del tipo: persona (nome, cognome, email) e azienda (nome).",
    youCanDirectlyEnterUUIDOfAUserOrCompanyToAddAsContact:
      "Puoi inserire direttamente l'UUID di un utente o azienda da aggiungere come contatto. Altrimenti, scegli il tipo di contatto da creare.",
    descriptionCreateQuote: "Inserisci i seguenti dettagli, sono necessari per creare un nuovo preventivo.",
    descriptionCreateOrder: "Inserisci i seguenti dettagli, sono necessari per creare un nuovo ordine.",
    descriptionCreateInvoice: "Inserisci i seguenti dettagli, sono necessari per creare una nuova fattura.",
    sorryLooksLikeThereAreSomeErrorstryAgain: "Spiacente, sembra che siano stati rilevati degli errori, per favore riprova.",
    sorryLooksLikeThereAreSomeErrorsTrySolve: "Spiacente, sembra che siano stati rilevati degli errori, prova a risolverli.",
    sorryThereIsNothingToAdd: "Spiacente, non c'è nulla da aggiungere, per favore riprova.",
    thankYouVeryMuchForSubscribingRedirectingToPreviousPage: "Grazie per esserti iscritto, reindirizzamento alla pagina precedente.",
    actionCompletedReturningToPage: "Azione completata, ritorno alla pagina.",
    actionCompletedRedirectingToPage: "Azione completata, reindirizzamento alla pagina.",
    pleaseModifyAddOrDeleteFieldsFromQuote: "Modifica, aggiungi e/o elimina i campi che desideri dal preventivo.",
    thisOptionIsUniqueAndNewOrderCannotBeCreatedFromThisQuote:
      "Questa opzione è unica e non può essere creato un nuovo ordine da questo preventivo.",
    descriptionCreateProviderInvoice: "Inserisci i seguenti dettagli, sono necessari per creare una nuova fattura fornitore.",
    pleaseModifyAddOrDeleteFieldsFromProviderInvoice: "Modifica, aggiungi e/o elimina i campi che desideri dalla fattura fornitore.",
    pleaseModifyAddOrDeleteFieldsFromExpense: "Modifica, aggiungi e/o elimina i campi che desideri dalla spesa.",
    descriptionCreateExpense: "Inserisci i seguenti dettagli, sono necessari per creare una nuova spesa.",
    descriptionCreateProviderOrder: "Inserisci i seguenti dettagli, sono necessari per creare un nuovo ordine fornitore.",
    pleaseModifyAddOrDeleteFieldsFromProviderOrder: "Modifica, aggiungi e/o elimina i campi che desideri dall'ordine fornitore.",
    fileFormatMaximum10MBPerFile: "Il formato del file è '.pdf' e la dimensione massima del file è 10 MB.",
    someOfTheUploadedFilesDoNotMeetTheRequiredCharacteristics: "Alcuni dei file caricati non soddisfano le caratteristiche richieste.",
    pleaseModifyAddOrDeleteFieldsFromOrder: "Modifica, aggiungi e/o elimina i campi che desideri dall'ordine.",
    pleaseModifyAddOrDeleteFieldsFromInvoice: "Modifica, aggiungi e/o elimina i campi che desideri dalla fattura.",
    thisAmountCanNotBeGreater: "Questo importo non può essere maggiore del totale del debito della fattura.",
    amountMinOfDueAndTransaction: "Minimo tra l'importo dovuto della fattura e l'importo della transazione.",
    toCreateAnDocument: "Per creare un documento, l'azienda deve contenere almeno un conto di tesoreria.",
    newContactWwillAddedToCompanyAndSelectDefault:
      "Un nuovo contatto verrà aggiunto all'azienda e selezionato come predefinito, ritorno alla pagina.",
    youHaveSuccessfullyResetYourPassword:
      "Hai reimpostato correttamente la password, ora puoi accedere nuovamente. Sarai reindirizzato alla pagina di login.",
    ifNoAmountIsEnteredTheValueWillBeZero: "Se non viene inserito alcun importo, il valore sarà 0.",
    ifYouWishYouCanAssignNameInLanguagesNecessary: "Se lo desideri, puoi assegnare il nome nelle lingue che ritieni necessarie.",
    productNameRequiredAndRecommendedUnique: "È richiesto un nome per il prodotto ed è consigliato che sia univoco.",
    addProductToCategory: "Aggiungi un prodotto a una categoria.",
    addTagsToProduct: "Aggiungi tag al prodotto, sono opzionali.",
    setProductMediaGallery: "Imposta la galleria multimediale del prodotto.",
    serviceNameRequiredAndRecommendedUnique: "È richiesto un nome per il servizio ed è consigliato che sia univoco.",
    addServiceToCategory: "Aggiungi un servizio a una categoria.",
    addTagsToService: "Aggiungi tag al servizio, sono opzionali.",
    setServiceMediaGallery: "Imposta la galleria multimediale del servizio.",
    aCategoryContainServicesProducts: "Una categoria può contenere sia servizi che prodotti.",
    ifSoAdditionalInformationRequired: "In tal caso, saranno necessarie ulteriori informazioni.",
    toPerformAnySubsequentActionWithInvoice:
      "Per eseguire qualsiasi azione successiva sulla fattura, deve essere nuovamente convalidata specificando i conti contabili corrispondenti a ciascun prodotto e/o servizio associato.",
    toPerformAnySubsequentActionWithProviderInvoice:
      "Per eseguire qualsiasi azione successiva sulla fattura fornitore, deve essere nuovamente convalidata specificando i conti contabili corrispondenti a ciascun prodotto e/o servizio associato.",
    toPerformAnySubsequentActionWithExpense:
      "Per eseguire qualsiasi azione successiva sulla spesa, deve essere nuovamente convalidata specificando i conti contabili corrispondenti a ciascun prodotto e/o servizio associato.",
    toPerformAnyFurtherActionProviderOrder: "Per eseguire ulteriori azioni con l'ordine del fornitore, sarà necessario crearne una copia.",
    validatingInvoiceSystemWillCreateToFollowingAccountingEntries:
      "Convalidando la fattura, il sistema creerà le seguenti registrazioni contabili. Conferma i conti contabili per ciascun servizio o prodotto nella fattura.",
    validatingProviderInvoiceSystemWillCreateToFollowingAccountingEntries:
      "Convalidando la fattura fornitore, il sistema creerà le seguenti registrazioni contabili. Conferma i conti contabili per ciascun servizio o prodotto nella fattura fornitore.",
    validatingExpenseSystemWillCreateToFollowingAccountingEntries:
      "Convalidando la spesa, il sistema creerà le seguenti registrazioni contabili. Conferma i conti contabili per ciascun servizio o prodotto nella spesa.",
    allowedFileTypes: "Tipi di file consentiti: png, jpg, jpeg.",
    whenYouUploadPdfFilesTheyArePlacedReferenceSupplieIinvoiceCreationform:
      "Quando carichi uno o più file PDF, vengono posizionati come riferimento nel modulo di creazione della fattura fornitore.",
    someFilesIncorrectlyFormattedAndTooLarge: "Alcuni file sono formattati in modo errato e altri sono troppo grandi.",
    someFilesIncorrectlyFormatted: "Alcuni file sono formattati in modo errato.",
    someFilesTooLarge: "Alcuni file sono troppo grandi.",
    searchSelectContact: "Cerca e seleziona un contatto.",
    accountingBookWithTotalAccountingEntriesCompany: "Libro contabile con le registrazioni contabili totali dell'azienda.",
    byDefaultSimpleWriting: "Di default viene creata una scrittura semplice.",
    selectAllPossibleOptions: "Seleziona tutte le opzioni possibili.",
    newManualAccountingBookCreated: "Verrà creato un nuovo libro contabile manuale.",
    selectOptionToEnableForm: "Seleziona un'opzione per abilitare il modulo.",
    selectApplicableScheme: "Seleziona il regime applicabile.",
    enterApplicableVatRate: "Inserisci l’aliquota IVA applicabile.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderOrder:
      "Il sistema sta aggiungendo i seguenti prodotti all'inventario dell'azienda. Si prega di confermare i centri di stoccaggio per ciascun prodotto nell'ordine del fornitore.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderInvoice:
      "Il sistema sta aggiungendo i seguenti prodotti all'inventario dell'azienda. Si prega di confermare i centri di stoccaggio per ciascun prodotto nell'ordine del fornitore.",
    addPaymentUsingCashOrCardOrDeposit: "Aggiungi un pagamento tramite contanti, carta o deposito.",

    // Lowercase sentences
    yearl: "anno",
    years: "anni",
    hour: "ora",
    hours: "ore",
    minute: "minuto",
    minutes: "minuti",
    items: "elementi",
    groups: "gruppi",
    selected: "selezionato",
    accountNeedsA: "il conto ha bisogno di un",
    options: "opzioni",
    with: "con",
    bestCustomers: "migliori clienti",
    byRecentUpdates: "per aggiornamenti recenti",
    byTimeRange: "per intervallo di tempo",
    template: "modello",
    evaluated: "valutato",
    noMailFound: "nessuna email trovata",
    report: "rapporto",
    reports: "rapporti",
    requestOnAccess: "richiesta di accesso all'azienda, la tua risposta è stata",
    userHasBeen: "è stato",
    yourAnswerHasBeen: ", la tua risposta è stata",
    toUser: "all'utente",
    hasBeen: "è stato",
    byYear: "per anno",
    or: "o",
    quotesToExpireThisMonth: "preventivi in scadenza questo mese",
    worstCustomers: "peggiori clienti",
    button: "pulsante",
    termsAndConditions: "termini e condizioni",
    and: "e",
    ourServicesOrRequesting: "i nostri servizi o richiedendo uno nuovo",
    toAddOrRemoveCategory: "che vuoi aggiungere o rimuovere dalla categoria",
    orCall: "o chiama",
    invoicesNotYetPaid: "fatture non ancora pagate",
    collections: "incassi",
    from: "da",

    // Interrogative sentences
    isDeliveryAddressTheSameAsCustomersAddress: "L'indirizzo di consegna è lo stesso dell'indirizzo del cliente?",
    youWantLogOut: "Vuoi uscire?",
    doesItTakeALongTimeToLoadTheApp: "Ci vuole molto tempo per caricare l'app?",
    alreadyHaveAnCccount: "Hai già un account?",
    forgotPassword: "Hai dimenticato la password?",
    newHere: "Nuovo qui?",
    doYouWantToSendInvitation: "Desideri inviare un invito per accedere all'azienda?",
    selectThisTreasuryAccountAsTheMainOne: "Selezionare questo conto di tesoreria come principale?",
    youWantToDeleteThisTreasuryAccount: "Vuoi eliminare questo conto di tesoreria?",
    youWantToSelectThisTreasuryAccountAsPrimary: "Vuoi selezionare questo conto di tesoreria come principale?",
    wantToExtendChangesToOtherCompanies: "Vuoi estendere le modifiche ad altre aziende?",
    youWantToDeleteThisContact: "Vuoi eliminare questo contatto?",
    youWantToDeleteSelectedContacts: "Vuoi eliminare i contatti selezionati?",
    youWantSendQuote: "Vuoi inviare il preventivo al cliente?",
    youWantToChangeQuoteStatusRejected: "Vuoi cambiare lo stato del preventivo in respinto?",
    youWantToGenerateAnOrderFromThisQuote: "Vuoi generare un ordine da questo preventivo?",
    youWantToChangeStatusTheExpense: "Vuoi cambiare lo stato della spesa?",
    youWantToDeleteThisDocument: "Vuoi eliminare questo documento?",
    youWantToRevertThisDocumentToDraft: "Vuoi riportare questo documento allo stato di bozza?",
    youWantToDeleteThisExpense: "Vuoi eliminare questa spesa?",
    youWantToChangeStatusTheProviderInvoice: "Vuoi cambiare lo stato della fattura del fornitore?",
    youWantToGenerateAProviderInvoiceFromThisProviderOrder: "Vuoi generare una fattura del fornitore da questo ordine del fornitore?",
    youWantToChangeOrderStatusToCanceled: "Vuoi cambiare lo stato dell'ordine in annullato?",
    youWantToGenerateAnInvoiceFromThisOrder: "Vuoi generare una fattura da questo ordine?",
    youWantToSendTheOrderToCustomer: "Vuoi inviare l'ordine al cliente?",
    youWantToCreateDeliveryNote: "Vuoi creare una bolla di consegna?",
    aFullDeliveryNoteWillBeCreated: "Verrà creata una bolla di consegna completa per tutti gli articoli di questo ordine",
    youWantToSendDeliveryNote: "Vuoi inviare questa bolla di consegna?",
    youWantToDeleteThisPayment: "Vuoi eliminare questo pagamento?",
    youWantToChangeStatusTheInvoice: "Vuoi cambiare lo stato della fattura?",
    isCompanyOwnerOfBankAccount: "L'azienda è proprietaria del conto bancario?",
    useReferenceWithinQR: "Usare un riferimento all'interno del QR?",
    youWantDeleteProduct: "Vuoi eliminare questo prodotto?",
    youWantDeleteSelectedProducts: "Vuoi eliminare i prodotti selezionati?",
    youWantToDeleteThisReminder: "Vuoi eliminare questo promemoria?",
    youWantToDeleteThisCategory: "Vuoi eliminare questa categoria?",
    youWantToDeleteTheStorageCenter: "Vuoi eliminare il centro di archiviazione?",
    youWantToDeleteSelectedCategories: "Vuoi eliminare le categorie selezionate?",
    youWantToDeleteTheStorageCenters: "Vuoi eliminare i centri di archiviazione?",
    youWantDeleteService: "Vuoi eliminare questo servizio?",
    youWantDeleteSelectedServices: "Vuoi eliminare i servizi selezionati?",
    isCompanySubjectVat: "L'azienda è soggetta a IVA?",
    wouldYouLikeUploadPdfFilesToRegistrationNnewInvoice:
      "Vuoi caricare uno o più file PDF per facilitare la registrazione di una nuova fattura?",
    howWouldLikeDeclareVat: "Come desideri dichiarare l’IVA?",
    youWantToDeleteThisPOS: "Vuoi eliminare questo POS?",
    doYouWantJoinNewCompany: "Desideri entrare a far parte della nuova azienda?",
    youWantToSendByEmail: "Vuoi inviare questo documento per email?",
    youWantToSendToCustomer: "Vuoi inviare questo al cliente?",
    youWantToDeleteThisAddress: "Vuoi eliminare questo indirizzo?",
    youWantToSetDefaultAddress: "Vuoi impostare questo indirizzo come predefinito?",
    youWantToRejectQuote: "Vuoi rifiutare questo preventivo?",
    youWantToRejectOrder: "Vuoi rifiutare questo ordine?",

    // Exclamative sentences
    important: "Importante!",
    exclamError: "Errore!",
    networkError: "Errore di rete!",
    httpError: "Errore HTTP!",
    yourSessionHasBeenClosed: "La tua sessione è stata chiusa, effettua il login!",
    yourSessionHasExpired: "La tua sessione è scaduta, effettua nuovamente il login!",
    accountNotValidated: "Account non ancora convalidato!",
    newRegisteredUser: "Nuovo utente registrato!",
    moneyBackGuarantee: "Garanzia di rimborso al 100%!",
    somethingWentWrong: "Qualcosa è andato storto!",
    thePageYouLookedNotFound: "La pagina che cercavi non è stata trovata!",
    yourSessionIsActiveCongratulations: "La tua sessione è attiva, congratulazioni!",
    weNeedYourAttention: "Abbiamo bisogno della tua attenzione!",
    yourAreDone: "Hai finito!",
    startCreatingNewTreasuryAccountsForYourCompany:
      "Inizia a creare nuovi conti di tesoreria per la tua azienda, è molto importante per il funzionamento dell'app!",
    itNotChangeCompany: "Non è possibile cambiare azienda!",
    weAreWorkingFeature: "Stiamo lavorando a questa funzionalità. Sarà disponibile molto presto!",
    processOfCreatingANewInvoiceCompleted: "Processo di creazione di una nuova fattura completato!",
    processOfUpdatingAInvoiceCompleted: "Processo di aggiornamento di una fattura completato!",
    thereAreNoTreasuryAccounts: "Non ci sono conti di tesoreria!",
    incorrectFiles: "File non corretti!",
    startAddingNewElementsToThisCategory: "Inizia ad aggiungere nuovi elementi a questa categoria!",
    accountingAccountAlreadySelected: "Conto contabile già selezionato, selezionane un altro!",
    servicesProductsWithTaxGreaterThanZero: "Servizi o prodotti con imposta maggiore di zero!",
    youHaveSuccessfullySignedOut: "Hai effettuato il logout con successo!",
    selectContactViewTheirAccountStatement: "Seleziona un contatto per visualizzare il suo estratto conto!",
    processOfCreatingANewOrderCompleted: "Processo di creazione di un nuovo ordine completato!",
    processOfUpdatingAnOrderCompleted: "Processo di aggiornamento di un ordine completato",
    processOfCreatingQuoteCompleted: "Processo di creazione di un nuovo preventivo completato!",
    processOfCreatingAQuoteFromAnotherQuoteCompleted: "Processo di creazione di un preventivo da un altro preventivo completato!",
    processOfCreatingAOrderFromAnotherOrderCompleted: "Processo di creazione di un ordine da un altro ordine completato!",
    processOfCreatingAInvoiceFromAnotherInvoiceCompleted: "Processo di creazione di una fattura da un'altra fattura completato!",
    processOfUpdatingAQuoteCompleted: "Processo di aggiornamento di un preventivo completato!",
    processOfCreatingANewExpenseCompleted: "Processo di creazione di una nuova spesa completato!",
    processOfUpdatingAnExpenseCompleted: "Processo di aggiornamento di una spesa completato!",
    processOfCreatingANewProviderInvoiceCompleted: "Processo di creazione di una nuova fattura fornitore completato!",
    processOfUpdatingAProviderInvoiceCompleted: "Processo di aggiornamento di una fattura fornitore completato!",
    processOfCreatedAProviderOrderCompleted: "Processo di creazione di un ordine fornitore completato!",
    processOfCreatedAProviderInvoiceCompleted: "Processo di creazione di una fattura fornitore completato!",
    processOfCreatingANewProviderOrderCompleted: "Processo di creazione di un nuovo ordine fornitore completato!",
    processOfUpdatingAProviderOrderCompleted: "Processo di aggiornamento di un ordine fornitore completato!",
    successfullyCreatedAccountingAccount: "Conto contabile creato con successo!",
    successfullyCreatedCategory: "Categoria creata con successo!",
    successfullyUpdatedCategory: "Categoria aggiornata con successo!",
    successfullyInvitationSent: "Invito inviato con successo!",
    successfullyInvitationCancel: "Invito annullato con successo!",
    successfullyCreatedContact: "Contatto creato con successo!",
    successfullyUpdatedContact: "Contatto aggiornato con successo!",
    successfullyCreatedReminder: "Promemoria creato con successo!",
    successfullyUpdatedStatus: "Stato aggiornato con successo!",
    successfullyUpdatedReminder: "Promemoria aggiornato con successo!",
    successfullyCreatedPayment: "Pagamento creato con successo!",
    successfullyCreatedCompanyParameters: "Parametri aziendali creati con successo!",
    successfullyUpdatedTreasuryAccount: "Conto di tesoreria aggiornato con successo!",
    successfullyAcceptedInvitation: "Invito accettato con successo!",
    successfullyLoggedIn: "Accesso effettuato con successo!",
    successfullyUpdatedCompanySettings: "Impostazioni aziendali aggiornate con successo!",
    successfullyCreatedCompany: "Azienda creata con successo!",
    successfullyDeletedPayment: "Pagamento eliminato con successo!",
    successfullyCreatedInvoice: "Fattura creata con successo!",
    successfullyDeletedReminder: "Promemoria eliminato con successo!",
    successfullyOrderSent: "Ordine inviato con successo!",
    successfullyQuoteSent: "Preventivo inviato con successo!",
    successfullyCreatedOrder: "Ordine creato con successo!",
    successfullyCreatedDeliveryNote: "Bolla di consegna creata con successo!",
    successfullyDeliveryNoteSent: "Bolla di consegna inviata con successo!",
    successfullyCreatedTreasuryAccount: "Conto di tesoreria creato con successo!",
    successfullyUpdatedDefaultTreasuryAccount: "Conto di tesoreria predefinito aggiornato con successo!",
    successfullyDeletedDocument: "Documento eliminato con successo!",
    successfullyDeletedTreasuryAccount: "Conto di tesoreria eliminato con successo!",
    successfullyCreatedAccountingEntry: "Voce contabile creata con successo!",
    successfullyUpdatedAccountingEntry: "Voce contabile aggiornata con successo!",
    successfullyUpdatedBookingJournal: "Registro di contabilità aggiornato con successo!",
    successfulllyCreatedUser: "Utente creato con successo!",
    successfullyCreatedStorageCenter: "Centro di archiviazione creato con successo!",
    successfullyUpdatedStorageCenter: "Centro di archiviazione aggiornato con successo!",
    successfullyCreatedStorageOperations: "Operazioni di stoccaggio create con successo!",
    successfullyUpdatedPos: "POS creato con successo!",
    successfullyUpdatedUser: "Utente aggiornato con successo!",
    successfullyAddedAddress: "Indirizzo aggiunto con successo!",
    successfullyUpdatedAddress: "Indirizzo aggiornato con successo!",
    successfullyDeletedAddress: "Indirizzo eliminato con successo!",
    successfullySetDefaultAddress: "Indirizzo predefinito impostato con successo!",
    successfullySentDocument: "Documento inviato con successo!",
    successfullyUpdated: "Aggiornato con successo!",

    // Answer sentences
    okGotIt: "Ok, capito",
    yesLogOut: "Sì, esci",
    noCancel: "No, annulla",
    noContinue: "No, continua",
    yesDelete: "Sì, elimina",
    yesResolveError: "Sì, risolvi l'errore",
    yesSelect: "Sì, seleziona",
    yesCanceled: "Sì, annulla",
    okClose: "Ok, chiudi",
    yesReject: "Sì, rifiuta",
    yesGenerate: "Sì, genera",
    yesSend: "Sì, invia",
    yesChangeStatus: "Sì, cambia stato",
    yesCreateTreasuryAccount: "Sì, crea conto di tesoreria",
    yesValidate: "Sì, valida",
    yesInvalidate: "Sì, invalida",
    yesUpload: "Sì, carica",
    noContinueForm: "No, continua con il modulo",
    yesAdd: "Sì, aggiungi",
    yesCreate: "Sì, crea",
    yesConfirm: "Sì, conferma",

    // Suspensive sentences
    pleaseWait: "Attendere prego...",
    selectOption: "Seleziona opzione...",
    searchContact: "Cerca contatto...",
    searchCategory: "Cerca categoria...",
    searchProduct: "Cerca prodotto...",
    searchService: "Cerca servizio...",
    searchStorage: "Cerca centro di stoccaggio...",
    searchBookingJournal: "Cerca registro contabile...",
    searchAccountingAccount: "Cerca conto contabile...",
    select: "Seleziona...",
    search: "Cerca...",
    writeCommentToInvite: "Scrivi un commento per l'invito...",
    loading: "Caricamento...",
    roles: "Ruoli",
    noRolesAvailable: "Nessun ruolo disponibile",
    noRolesDefinedForCompany: "Nessun ruolo è definito per questa società.",
    noAssignableRoles: "Il tuo ruolo non ti consente di assegnare alcun ruolo. Contatta un amministratore.",
    roleNotAssignableByYou: "Il tuo ruolo non ti consente di assegnare questo ruolo",
    roleAssignmentForbidden: "Il tuo ruolo non consente di assegnare questo ruolo",
    subscriptionExpiredAction: "Il tuo abbonamento è scaduto",
    system: "Sistema",
    administration: "Amministrazione",
    admin: "Admin",
    member: "Membro",
    assignedRoles: "Ruoli assegnati",
    assignRole: "Assegna",
    removeRole: "Rimuovi",
    manageRoles: "Gestisci ruoli",
    revoke: "Revoca",
    reinvite: "Re-invita",
    invite: "Invita",
    role: "Ruolo",
    statusPending: "In attesa",
    statusAccepted: "Accettato",
    statusRejected: "Rifiutato",
    statusExpired: "Scaduto",
    expiresAt: "Scade il",
    noMembers: "Nessun membro trovato",
    confirmRevoke: "Sei sicuro di voler revocare questo invito?",
    confirmRemoveRole: "Sei sicuro di voler rimuovere questo ruolo?",
    policies: "Politiche",
    createRole: "Crea ruolo",
    createPolicy: "Crea politica",
    attachedPolicies: "Politiche allegate",
    attachPolicy: "Allegare",
    detachPolicy: "Staccare",
    statements: "Dichiarazioni",
    addStatement: "Aggiungi dichiarazione",
    removeStatement: "Rimuovi dichiarazione",
    effect: "Effetto",
    allow: "Consenti",
    deny: "Nega",
    actionsList: "Azioni",
    resources: "Risorse",
    resourcesHint: "Identificatori di risorse separati da virgole, usa * per tutti",
    noRoles: "Nessun ruolo trovato",
    noPolicies: "Nessuna politica trovata",
    confirmDeleteRole: "Sei sicuro di voler eliminare questo ruolo?",
    confirmDeletePolicy: "Sei sicuro di voler eliminare questa politica?",
    systemReadOnly: "Questo è un elemento di sistema e non può essere modificato",
    loadingCatalog: "Caricamento catalogo risorse...",
    emptyCatalog: "Nessuna risorsa disponibile",
    advancedMode: "Avanzato",
    preview: "Anteprima",

    // Abbreviated sentences
    n: "N°",
    mb: "MB",
    hrs: "ore",
    min: "min",
    sec: "sec",

    // Enumeration
    first: "primo",
    second: "secondo",
    third: "terzo",
    fourth: "quarto",
    fifth: "quinto",
    sixth: "sesto",

    // Languages
    english: "Inglese",
    french: "Francese",
    italian: "Italiano",
    german: "Tedesco",
    spanish: "Spagnolo",

    // Months
    january: "Gennaio",
    february: "Febbraio",
    march: "Marzo",
    april: "Aprile",
    may: "Maggio",
    june: "Giugno",
    july: "Luglio",
    august: "Agosto",
    september: "Settembre",
    october: "Ottobre",
    november: "Novembre",
    december: "Dicembre",

    // Periods
    monthly: "Mensile",
    quarterly: "Trimestrale",
    semiannual: "Semestrale",
    annual: "Annuale",
    createAccount: "Crea conto",
    createSiblingAccount: "Crea conto fratello",
    createChildAccount: "Crea sottoconto",
    siblingOf: "Fratello di",
    subAccountOf: "Sottoconto di",
    nameFr: "Nome (francese)",
    nameEn: "Nome (inglese)",
    nameDe: "Nome (tedesco)",
    nameIt: "Nome (italiano)",
    codeAndNameFrRequired: "Codice e nome francese sono obbligatori",
    accountCreatedSuccessfully: "Conto creato con successo",
    renameAccount: "Rinominare il conto",
    accountRenamedSuccessfully: "Conto rinominato con successo",
    siblingCodeHint: "4 cifre — es. 1005",
    childCodeHint: "XXXX.N — es. 1000.01",
    siblingAccount: "Conto fratello",
    subAccount: "Sottoconto",
    referenceAccount: "Conto di riferimento",
    creationMode: "Modalità di creazione",
    foreignCurrency: "Valuta estera",
    enableForeignCurrency: "Fatturare in valuta estera",
    exchangeRate: "Tasso di cambio",
    exchangeDate: "Data del tasso",
    foreignCurrencyPreview: "Anteprima dell'importo convertito",
    convertedTotal: "Totale convertito",
    rateInfo: "Info tasso di cambio",
    amountInCurrency: "Importo in {currency}",
    amountInCHF: "Importo CHF",
    partialBalance: "Parziale (senza conversione)",
    approxBalanceTooltip: "Riga/e senza tasso di cambio — saldo {currency} approssimativo",
    partialLinesFooter: "parziale ({count} righe senza tasso)",
    currencyColumn: "Valuta",
    vatPeriodicity: "Periodicità IVA",
    firstPeriod: "Primo periodo",
    deductionMethod: "Metodo di deduzione",
    methodInvoicing: "Secondo il metodo di fatturazione",
    methodCashing: "Secondo il metodo di incasso",
    periodConfigured: "Periodi fiscali configurati",
    periodOpen: "Aperto",
    periodClosed: "Chiuso",
    periodFiled: "Depositato",
    closePeriod: "Chiudere il periodo",
    taxSettingsLocked: "Le impostazioni IVA sono bloccate perché è stato creato un periodo fiscale. Per modificarle, contattare il proprio fiduciario.",
    taxSettingsLockedContact: "Se desidera modificare il regime IVA, deve contattare",
    period: "Periodo",
    format: "Formato",
    reconciliation: "Riconciliazione",
    bankStatements: "Estratti conto",
    importStatement: "Importa estratto",
    importBankStatement: "Importa estratto conto",
    allTreasuryAccounts: "Tutti i conti di tesoreria",
    statementDate: "Data dell'estratto",
    openingBalance: "Saldo di apertura",
    closingBalance: "Saldo di chiusura",
    importFailed: "Importazione fallita",
    dragAndDropOrClick: "Trascina un file qui o clicca per selezionare",
    importing: "Importazione...",
    importAction: "Importa",
    autoMatchInfo: "Dopo l'importazione, verrà avviata una riconciliazione automatica per abbinare le transazioni alle fatture esistenti.",
    importSourceStructured: "File strutturato (CAMT/CSV)",
    importSourcePdfUpload: "PDF — caricare",
    importSourcePdfExisting: "PDF — documento esistente",
    extractingStatement: "Estrazione dell'estratto in corso…",
    preparingDocument: "Preparazione del documento…",
    extractionFailed: "Estrazione fallita. Riprova.",
    selectExistingDocument: "Scegli un documento esistente",
    noPdfDocumentsAvailable: "Nessun documento PDF disponibile",
    retryExtraction: "Riprova estrazione",
    extractionTimeout: "L'estrazione sta richiedendo più tempo del previsto. Riprova più tardi.",
    jobQueued: "In coda...",
    jobFailed: "Fallito",
    heuristicSuggestions: "Suggerimenti euristici",
    unmatchedLines: "Righe non riconciliate",
    bankTransactions: "Transazioni",
    oneStatementNeedingAttention: "1 estratto richiede attenzione",
    statementsNeedingAttention: "estratti richiedono attenzione",
    someTransactionsNotReconciled: "Alcune transazioni non sono ancora riconciliate",
    continueReconciliation: "Continua la riconciliazione",
    finishReconciliation: "Termina la riconciliazione",
    counterpartIban: "IBAN controparte",
    matchedVia: "Metodo",
    noTransactionsFound: "Nessuna transazione trovata",
    viewStatement: "Visualizza estratto",
    alreadyImported: "Già importata",
    overlapWarning: "Questo periodo si sovrappone a {n} estratto/i già importato/i per questo conto.",
    duplicatesUnchecked: "{x} transazione/i già presente/i deselezionata/e automaticamente.",
    includeLine: "Includi",
    confirmed: "Confermato",
    sortByPeriod: "Ordina per periodo",
    confirmDeleteStatement: "Eliminare l'estratto conto bozza?",
    confirmDeleteStatementText: "Questo estratto conto bozza e il documento associato verranno eliminati definitivamente. Questa azione non può essere annullata.",
    existingPayments: "Pagamenti esistenti",
    linkThisPayment: "Collega questo pagamento",
    link: "Collega",
    autoMatchAll: "Riconciliazione auto",
    exportTransactions: "Esporta transazioni",
    reconcile: "Riconcilia",
    reconcileAutomatically: "Riconcilia automaticamente",
    paid: "Pagata",
    entry: "Registrazione",
    documentsToValidate: "Documenti da validare",
    validateAndReconcile: "Valida e riconcilia",
    toValidate: "Da validare",
    dateFrom: "Da",
    dateTo: "A",
    resetFilters: "Ripristina",
    transactions: "transazioni",
    previous: "Precedente",
    next: "Successivo",
    matched: "Riconciliato",
    ignored: "Ignorato",
    relaunchAutoMatch: "Rilanciare riconciliazione automatica",
    matching: "Riconciliazione",
    starting: "Avvio",
    jobRunning: "Riconciliazione automatica in corso",
    linesProcessed: "Righe elaborate",
    noLinesPending: "Nessuna riga in sospeso",
    matchManually: "Riconcilia manualmente",
    match: "Riconcilia",
    unmatch: "Annulla riconciliazione",
    ignore: "Ignora",
    noLinesInStatement: "Nessuna riga in questo estratto",
    statementNotFound: "Estratto non trovato",
    confirmUnmatch: "Annullare la riconciliazione?",
    unmatchWillDeleteEntry: "La registrazione contabile associata potrebbe essere eliminata.",
    yesUnmatch: "Sì, annulla",
    confirmIgnore: "Ignorare questa riga?",
    yesIgnore: "Sì, ignora",
    restoreLine: "Ripristina",
    lineRestored: "Riga ripristinata in attesa.",
    saveDraft: "Salva",
    draftSaved: "Bozza salvata.",
    savingDraft: "Salvataggio…",
    unsavedChanges: "Modifiche non salvate",
    unsavedChangesBody: "Hai modifiche non salvate. Cosa vuoi fare?",
    quitWithoutSaving: "Esci senza salvare",
    statementNotDraft: "Questo estratto non è più una bozza. Ricaricamento…",
    jobAlreadyRunning: "La riconciliazione automatica è già in corso",
    noCandidatesFound: "Nessun candidato trovato",
    score: "Punteggio",
    pending: "In sospeso",
    reconcileAndCollect: "Riconciliare e incassare",
    partialCollection: "incasso parziale",
    deleteStatement: "Elimina estratto conto",
    confirmDeleteStatementTitle: "Eliminare questo estratto conto?",
    confirmDeleteStatementBody: "Questa azione elimina l'estratto conto e le sue {count} transazione/i non riconciliata/e.",
    statementDeleted: "Estratto conto eliminato con successo.",
    cannotDeleteMatchedLines: "Impossibile: {count} transazione/i riconciliata/e. Scollegate prima le riconciliazioni.",
    cannotDeleteMatchedLinesTooltip: "Impossibile: {count} transazione/i riconciliata/e. Scollegate prima le riconciliazioni.",
    statementHasMatchedLinesError: "Questo estratto conto contiene {count} transazione/i riconciliata/e. Scollegatele prima di eliminare.",
    invalidateStatement: "Invalidare",
    confirmInvalidateStatementTitle: "Invalidare questo estratto conto?",
    confirmInvalidateStatementBody: "L'estratto conto tornerà in bozza per la correzione. Le sue {count} transazione/i non saranno più disponibili per la riconciliazione. Il documento importato resta allegato.",
    statementInvalidated: "Estratto conto riportato in bozza.",
    confirmInvalidate: "Sì, invalidare",

    // VAT Return
    vatReturn: "Rendiconto IVA",
    vatSectionTurnover: "I. Cifra d'affari",
    vatSectionTaxCalculation: "II. Calcolo dell'imposta",
    vatSectionOtherFlows: "III. Altri flussi di fondi",
    vatTaxDue: "Imposta dovuta",
    vatInputTax: "Imposta precedente",
    vatBalance: "Saldo a favore dell'AFC / del contribuente",
    vatTax: "Imposta",
    vatCaseComposition: "Composizione della cifra",
    vatCounterServices: "Controprestazioni",
    vatDeductions: "Deduzioni",
    vatTaxableTurnover: "Cifra d'affari imponibile",
    vatAmountToPayAFC: "Importo da versare all'AFC",
    vatBalanceInFavor: "Saldo a favore del contribuente",
    vatTotalDeductions: "Totale deduzioni",
    vatTotalTaxDue: "Totale imposta dovuta",
    vatTotalInputTax: "Totale imposta precedente",
    vatNormalRate: "Prestazioni all'aliquota normale",
    vatReducedRate: "Prestazioni all'aliquota ridotta",
    vatAccommodationRate: "Prestazioni all'aliquota speciale",
    vatAcquisitions: "Imposta sull'acquisto (netto, escl. IVA)",
    caseNumber: "Cifra",
    base: "Base",
    sign: "Segno",
    nature: "Natura",
    reference: "Riferimento",
    back: "Indietro",
    accountingDocument: "Documento contabile",
    documentNumber: "Numero documento",
    entryNumber: "Numero registrazione",
    entryNumberShort: "N.",
    manualEntry: "Registrazione manuale",
    createAndReconcile: "Crea e riconcilia",
    gap: "Differenza",
    editVatAdjustment: "Modifica rettifica IVA",
    noteOptional: "Nota (opzionale)",
    vouchersSoonAvailable: "Giustificativi (disponibili a breve)",
    periodIsFiledCannotEdit: "Questo periodo è chiuso. Le rettifiche non possono essere modificate.",
    csvImport: "Importazione CSV",
    difference: "Differenza",
    balanced: "Bilanciato",
    unbalanced: "Sbilanciato",
    saveOpeningBalance: "Salva bilancio di apertura",
    forceReprise: "Forzare la ripresa",
    forceRepriseWarning: "L'esercizio precedente è chiuso. Forzare sovrascriverà la registrazione di apertura automatica. Sei sicuro?",
    csvFormatHelp: "Formati CSV accettati (separatore punto e virgola):",
    csvFormatBHelp: "1000;15000 (positivo = dare, negativo = avere)",
    closedFiscalYearReadonly: "Questo esercizio è chiuso. Il bilancio di apertura non può essere modificato.",
    deleteOpeningBalance: "Elimina bilancio di apertura",
    confirmDeleteOpeningBalance: "Sei sicuro di voler eliminare il bilancio di apertura? Tutti gli importi verranno azzerati.",
    amountMustBePositive: "L'importo deve essere positivo — utilizzare la colonna dare o avere.",

    // Period status transitions
    filePeriod: "Depositare",
    reopenPeriod: "Riaprire",
    confirmClosePeriod: "Sei sicuro di voler chiudere questo periodo? Le registrazioni non saranno più modificabili finché il periodo non verrà riaperto.",
    confirmFilePeriod: "Sei sicuro di voler depositare questo periodo? Questa azione è definitiva e non può essere annullata.",
    confirmFilePeriodWarning: "Una volta depositato, il conteggio IVA sarà congelato e nessuna modifica sarà possibile.",
    confirmReopenPeriod: "Sei sicuro di voler riaprire questo periodo? Le registrazioni torneranno modificabili.",

    // Fiscal Years
    fiscalYears: "Esercizi contabili",
    fiscalYear: "Esercizio contabile",
    newFiscalYear: "Nuovo esercizio",
    closeFiscalYear: "Chiudi esercizio",
    closeFiscalYearConfirm: "Sei sicuro di voler chiudere questo esercizio contabile? Questa azione è irreversibile. Tutte le registrazioni saranno bloccate e nessuna modifica sarà possibile.",
    closeFiscalYearWarning: "Questa azione è irreversibile. Una volta chiuso, nessuna registrazione potrà essere aggiunta o modificata per questo esercizio.",
    reopenFiscalYear: "Riaprire l'esercizio",
    reopenFiscalYearConfirm: "Sei sicuro di voler riaprire questo esercizio contabile?",
    reopenFiscalYearWarning: "La registrazione di chiusura, il riporto a nuovo e l'assegnazione del risultato dell'esercizio successivo saranno eliminati. I periodi saranno riaperti. Potrai richiudere l'esercizio in seguito.",
    reopenFiscalYearFirstReopen: "Riapri prima l'esercizio {name}",
    noFiscalYears: "Nessun esercizio contabile trovato",
    createFiscalYear: "Crea esercizio",
    editFiscalYear: "Modifica esercizio",
    deleteFiscalYear: "Elimina esercizio",
    confirmDeleteFiscalYear: "Sei sicuro di voler eliminare definitivamente questo esercizio contabile? Questa azione non può essere annullata.",
    fiscalYearStartDate: "Data di inizio dell'esercizio",
    fiscalYearClosingYear: "Anno di chiusura",
    fiscalYearEndDate: "Data di fine dell'esercizio",
    fiscalYearEndForced: "L'esercizio contabile termina sempre il 31 dicembre",
    accountingSettingsInitializing: "Inizializzazione in corso…",

    // Annual correction
    annualCorrection: "Concordanza annuale",
    createAnnualCorrection: "Crea concordanza annuale",
    viewAnnualCorrection: "Vedi concordanza",
    confirmCreateAnnualCorrection: "Creare la concordanza annuale per questo esercizio? I ticket orfani verranno assegnati a un nuovo periodo di concordanza.",
    periodsNotAllFiled: "Tutti i periodi devono essere depositati prima di creare la concordanza annuale.",
    noOrphans: "Nessun ticket orfano da correggere per questo esercizio.",
    ticketsPending: "ticket in attesa",

    // Vouchers
    confirmDeleteVoucher: "Sei sicuro di voler rimuovere questo giustificativo?",
    pendingUpload: "in attesa",
    uploadFailed: "Il caricamento non è riuscito per uno o più file. L'importo e la nota sono stati salvati.",
    addVoucher: "Aggiungi giustificativo",

    // Manual entries
    vatInputType: "Tipo di imposta precedente",
    vatInputGoods: "Merci e materiali",
    vatInputInvestment: "Investimenti e altri oneri",
    deleteAccountingEntry: "Elimina scrittura",
    confirmDeleteAccountingEntry: "Sei sicuro di voler eliminare questa scrittura?",

    // Financial statements
    balanceSheet: "Bilancio",
    incomeStatement: "Conto economico",
    trialBalance: "Bilancio di verifica",
    assets: "Attivi",
    liabilities: "Passivi",
    revenue: "Ricavi",
    netResult: "Risultato d'esercizio",
    asOfDate: "Al",
    previousYear: "Esercizio precedente",
    variation: "Variazione",
    notBalanced: "Non equilibrato",
    sortByCode: "Ordina per conto",
    sortByBalance: "Ordina per saldo",
    allLevels: "Tutti i livelli",
    profitOfYear: "Utile dell'esercizio",
    lossOfYear: "Perdita dell'esercizio",
    viewList: "Lista",
    viewColumns: "Affiancato",
    totalLiabilitiesAndResult: "Totale passivi e risultato",
    viewVouchers: "Visualizza allegati",
    pendingDocuments: "documento/i in attesa",
    showZeroAccounts: "Mostra conti a saldo zero",
    hideZeroAccounts: "Nascondi conti a saldo zero",
    chatTitle: "Chat",
    chatConversations: "Conversazioni",
    chatNewConversation: "Nuova conversazione",
    chatNoConversations: "Nessuna conversazione",
    chatNoMessages: "Nessun messaggio. Di' ciao!",
    chatPlaceholder: "Scrivi un messaggio...",
    chatSend: "Invia",
    chatYou: "Tu",
    chatBack: "Indietro",
    chatStartConversation: "Chat",
    chatSelectMember: "Seleziona un membro",
    chatLoadingMembers: "Caricamento membri...",
    chatNoMembers: "Nessun membro trovato",
    chatLoadingMessages: "Caricamento messaggi...",
    chatActive: "Attivo",
    featureLabelContacts: "Contatti & CRM",
    featureLabelSaleCore: "Vendite & fatturazione",
    featureLabelPurchaseCore: "Acquisti & fatture fornitori",
    featureLabelTreasuryPayments: "Pagamenti & riconciliazione bancaria",
    featureLabelCatalog: "Catalogo prodotti & servizi",
    featureLabelAccountingCore: "Contabilità",
    featureLabelArchiveOcr: "Archivio documenti & OCR",
    featureLabelNetworkInterbilling: "Fatturazione interaziendale",
    featureLabelPaymentOnline: "Pagamenti online",
    featureLabelDunning: "Solleciti & promemoria",
    featureLabelSaleRecurring: "Fatturazione ricorrente",
    featureLabelTreasuryEbanking: "Connessione e-banking",
    featureLabelTreasuryForecast: "Previsione di tesoreria",
    featureLabelProjectsTime: "Progetti & rilevazione ore",
    featureLabelPos: "Punto vendita",
    featureLabelExpenses: "Note spese",
    featureLabelInventory: "Gestione magazzino",
    featureLabelSaleConsignment: "Vendite in conto deposito",
    featureLabelAccountingAssets: "Gestione cespiti",
    featureLabelServiceRepair: "Tracciamento riparazioni",
    featureLabelRbacAdvanced: "Controllo accessi avanzato",
    featureLabelMultiCompany: "Multi-azienda",
    featureLabelPayroll: "Gestione stipendi",
    featureLabelStorefront: "Negozio online",
    featureLabelEsignature: "Firma elettronica",
    featureLabelMobileSale: "App mobile vendite",
    featureLabelMobileExpenses: "Registrazione spese mobile",
    featureLabelSupportPriority: "Supporto prioritario",
    searchDocuments: "Cerca documenti",
    searchDocumentsPlaceholder: "Cerca documenti (nome, contenuto OCR)...",
    searchingDocuments: "Ricerca in corso...",
    searchDocumentsResultsCount: "{{count}} risultato/i per \"{{query}}\"",
    searchDocumentsNoResults: "Nessun risultato per \"{{query}}\"",
    filterDocumentStatus: "Stato del documento",
    filterDocumentDateFrom: "Data documento dal",
    filterDocumentDateTo: "Data documento al",
    filterUploadDateFrom: "Data caricamento dal",
    filterUploadDateTo: "Data caricamento al",
    statementToValidate: "Estratto da validare",
    draftMode: "Modalità bozza",
    confirmImport: "Conferma importazione",
    extractedByVision: "Estratto tramite analisi immagine",
    extractedByText: "Estratto tramite testo",
    reconciliationGapWarning: "Scarto di {gap} — verifica le righe",
    confirmUnbalancedTitle: "Estratto non bilanciato",
    confirmUnbalancedText: "L'estratto non è bilanciato. Confermare comunque?",
    ocrStatus: "Stato OCR",
    uploadedAt: "Caricato il",
    pageXofN: "Pagina {page} di {pages}",
    filterByStatus: "Filtra per stato",
    allStatuses: "Tutti",
    statusNew: "Nuovo",
    statusAssigned: "Assegnato",
    statusPartiallyProcessed: "Parzialmente elaborato",
    statusProcessed: "Elaborato",
    createFullInvoice: "Fattura completa",
    depositInvoice: "Fattura di acconto",
    partialInvoice: "Fattura parziale",
    depositAmount: "Importo dell'acconto",
    depositDescription: "Descrizione",
    quantityToInvoice: "Quantità da fatturare",
    remainingQuantity: "Rimanente",
    invoicedQuantity: "Fatturato",
    totalQuantity: "Totale",
    notInvoiced: "Non fatturata",
    partiallyInvoiced: "Parzialmente fatturata",
    fullyInvoiced: "Completamente fatturata",
    invoicingStatus: "Stato fatturazione",
    invoicedAmountOf: "fatturato su",
    linkedInvoices: "Fatture collegate",
    noInvoicesYet: "Nessuna fattura per il momento",
    youWantToCreateDepositInvoice: "Vuoi creare una fattura di acconto?",
    youWantToCreatePartialInvoice: "Vuoi creare una fattura parziale?",
    noLinesToInvoice: "Nessuna riga da fatturare",
    depositAmountExceedsRemaining: "L'importo supera il saldo rimanente",
    manageStock: "Gestire lo stock",
    stockManagedDescription: "Ogni vendita decrementerà automaticamente lo stock del centro di stoccaggio.",
    stockDisabledDescription: "Nessun movimento di stock sarà generato per le vendite di questa cassa.",
    stockManaged: "Stock gestito",
    withoutStockManagement: "Senza gestione stock",
    recipient: "Destinatario",
    emailSubject: "Oggetto",
    emailMessage: "Messaggio",
    emailSent: "Email inviata con successo",
    emailDefaultMessage: "In allegato trova il documento indicato nell'oggetto.",
    correctAccounts: "Correggere i conti",
    saveCorrection: "Salvare la correzione",
    correctingAccountsDescription: "È possibile correggere i conti di contropartita di questo documento. La registrazione contabile verrà aggiornata sul posto.",
    successfullyCorrectedAccounts: "Conti corretti con successo",

    // Payroll
    payroll: "Stipendi",
    payrollShort: "Stipendi",
    employees: "Dipendenti",
    addEmployee: "Aggiungere dipendente",
    editEmployee: "Modificare dipendente",
    employeeNumber: "Numero dipendente",
    searchEmployee: "Cercare dipendente...",
    noEmployeesFound: "Nessun dipendente trovato",
    employeeStatusActive: "Attivo",
    employeeStatusDraft: "Bozza",
    employeeStatusTerminated: "Cessato",
    workCanton: "Cantone di lavoro",
    activityRate: "Grado di occupazione",
    employmentContract: "Contratto di lavoro",
    avsNumber: "Numero AVS",
    residencePermit: "Permesso di soggiorno",
    backToList: "Torna alla lista",
    backToDashboard: "Torna alla dashboard",
    featureComingSoon: "Questa funzionalità sarà presto disponibile.",
    payrollAccessDenied: "Accesso negato",
    payrollAccessDeniedOwnerOnly: "Il modulo stipendi è riservato al proprietario dell'azienda. Contattare l'amministratore se si ritiene di dover avere accesso.",
    payrollAccessDeniedReconnect: "Se le autorizzazioni sono state aggiornate di recente, disconnettersi e riconnettersi per aggiornare la sessione.",

    // Payroll forms
    identity: "Identità",
    birthDate: "Data di nascita",
    gender: "Genere",
    gender_male: "Maschile",
    gender_female: "Femminile",
    civilStatus: "Stato civile",
    civilStatus_single: "Celibe/Nubile",
    civilStatus_married: "Sposato/a",
    civilStatus_divorced: "Divorziato/a",
    civilStatus_widowed: "Vedovo/a",
    civilStatus_registered_partnership: "Unione registrata",
    civilStatus_dissolved_partnership: "Unione sciolta",
    civilStatusSince: "Stato civile dal",
    civilStatusSinceHelp: "Determina la tariffa d'imposta alla fonte applicabile. Un cambiamento di stato civile ha effetto il mese successivo all'evento.",
    nationality: "Nazionalità",
    permitType: "Tipo di permesso",
    permitNumber: "Numero di permesso",
    permitValidUntil: "Valido fino al",
    issuingCanton: "Cantone di rilascio",
    swissNational: "Cittadino svizzero",
    permit: "Permesso",
    residence: "Residenza",
    canton: "Cantone",
    municipality: "Comune",
    familySituation: "Situazione familiare",
    hasSpouse: "Ha coniuge / partner registrato",
    spouseIsWorking: "Il coniuge lavora",
    spouseWorkCanton: "Cantone di lavoro del coniuge",
    spouseWorkCountry: "Paese di lavoro del coniuge",
    children: "Figli",
    addChild: "Aggiungere figlio",
    child: "Figlio",
    allowanceFrom: "Assegno dal",
    allowanceTo: "Assegno fino al",
    inEducation: "In formazione",
    paymentDetails: "Dettagli di pagamento",
    bic: "BIC/SWIFT",
    accountHolder: "Titolare del conto",
    notes: "Note",
    linkedContact: "Contatto collegato",
    searchContact: "Cercare un contatto esistente...",
    contactRequired: "Selezionare un contatto",
    refreshSnapshot: "Aggiornare i dati del contatto",
    change: "Modificare",

    // Contract form
    contractHistory: "Storico contratti",
    addContractVersion: "Aggiungere versione contratto",
    newContractVersion: "Nuova versione contratto",
    editContract: "Modificare contratto",
    newVersionWarning: "Verrà creata la versione {version} del contratto, in vigore dalla data impostata. La versione {prevVersion} verrà chiusa automaticamente.",
    contractType: "Tipo di contratto",
    contractType_permanent: "Indeterminato",
    contractType_fixed_term: "Determinato",
    contractType_apprenticeship: "Apprendistato",
    contractType_internship: "Tirocinio",
    salaryMode: "Modalità salariale",
    salaryMode_monthly: "Mensile",
    salaryMode_hourly: "Orario",
    hireDate: "Data di assunzione",
    endReason: "Motivo di cessazione",
    weeklyHours: "Ore settimanali",
    probationMonths: "Periodo di prova (mesi)",
    noticePeriod: "Preavviso (mesi)",
    salary: "Salario",
    baseSalary: "Salario base",
    thirteenthSalary: "Tredicesima",
    thirteenthMode: "Modalità di pagamento",
    thirteenthMode_december: "Dicembre",
    thirteenthMode_monthly_provision: "Accantonamento mensile",
    thirteenthModeHelp: "Versamento a dicembre — la tredicesima viene versata integralmente a dicembre. In caso di uscita durante l'anno, la quota maturata viene versata nel conteggio finale.\n\nAccantonamento mensile — un dodicesimo viene versato ogni mese con la busta paga corrente. Nessun versamento a dicembre.",
    vacation: "Vacanze",
    vacationDays: "Giorni all'anno",
    vacationRate: "Supplemento vacanze (%)",
    workplace: "Luogo di lavoro",
    workplaceAddressCompany: "Indirizzo dell'azienda",
    workplaceAddressOther: "Altro indirizzo",
    validFrom: "In vigore dal",
    validTo: "Fino al",
    version: "Versione",
    current: "Attuale",
    closed: "Chiuso",
    future: "Futuro",
    noContracts: "Nessun contratto",
    // Contract termination
    terminateContract: "Risolvere il contratto",
    confirmTermination: "Confermare la risoluzione",
    terminationConsequences: "La risoluzione del contratto avrà i seguenti effetti:",
    terminationStatusChange: "Lo stato del dipendente cambierà in <strong>risolto</strong>",
    terminationFinalSettlement: "Un <strong>conteggio finale</strong> sarà prodotto nel periodo di paga contenente questa data",
    terminationExclusion: "Il dipendente sarà <strong>escluso dai cicli di paga successivi</strong>, salvo per adeguamenti retroattivi",
    terminationWarning: "La risoluzione di un contratto genera un conteggio finale nel periodo di paga contenente la data di fine. Questa azione può essere annullata prima della validazione del ciclo di paga.",
    contractTerminated: "Contratto risolto",
    cancelTermination: "Annullare la risoluzione",
    cancelTerminationConfirm: "Sei sicuro di voler annullare questa risoluzione? Il dipendente tornerà allo stato attivo.",
    terminationCancelled: "Risoluzione annullata",
    terminated: "Risolto",
    endReason_resignation: "Dimissioni",
    endReason_dismissal: "Licenziamento",
    endReason_mutual_agreement: "Accordo reciproco",
    endReason_end_of_term: "Scadenza del termine",
    endReason_retirement: "Pensionamento",
    endReason_death: "Decesso",
    endReason_disability: "Invalidità",
    endReason_probation: "Fine del periodo di prova",

    // Payroll — Company salary settings
    salarySettings: "Impostazioni salariali",
    insurancePlans: "Piani assicurativi",
    payrollSettings: "Impostazioni libro paga",
    payrollCompleteness: "Stato di preparazione",
    payrollCompletenessOk: "Tutte le impostazioni richieste sono configurate. Lo stipendio può essere calcolato.",
    payrollCompletenessMissing: "Le seguenti impostazioni devono essere completate prima di poter calcolare lo stipendio:",
    insurancePlanType_laap: "LAINF Professionale (LAINF-P)",
    insurancePlanType_laanp: "LAINF Non professionale (LAINF-NP)",
    insurancePlanType_laac: "LAINF Complementare (LAINF-C)",
    insurancePlanType_ijm: "Indennità giornaliera malattia (IGM)",
    insurancePlanType_lpp: "Previdenza professionale (LPP)",
    insurerName: "Nome dell'assicuratore",
    policyNumber: "Numero di polizza",
    rateEmployee: "Contributo dipendente (%)",
    rateEmployer: "Contributo datore di lavoro (%)",
    riskClass: "Classe di rischio",
    lppRatesByAge: "Contributi per fascia d'età",
    lppAgeFrom: "Da età",
    lppAgeTo: "A età",
    addAgeBracket: "Aggiungere fascia d'età",
    coordinationDeductionOverride: "Deduzione di coordinamento (override)",
    entryThresholdOverride: "Soglia d'ingresso (override)",
    addInsurancePlan: "Aggiungere piano assicurativo",
    editInsurancePlan: "Modificare piano assicurativo",
    noInsurancePlans: "Nessun piano assicurativo",
    effectiveSince: "In vigore dal {date}",
    closurePlanWarning: "Questo piano entrerà in vigore il {date}. Il piano {type} attuale verrà chiuso il {closureDate}.",
    confirmDeletePlan: "Eliminare questo piano assicurativo?",
    deletePlan: "Eliminare piano",
    avsFund: "Cassa AVS",
    avsFundName: "Nome della cassa",
    avsMemberNumber: "Numero di affiliazione",
    avsAdministrationRate: "Contributo amministrativo (%)",
    familyAllowanceFund: "Cassa assegni familiari",
    familyAllowanceFundName: "Nome della cassa",
    familyAllowanceMemberNumber: "Numero di affiliazione",
    withholdingTax: "Imposta alla fonte",
    withholdingTaxCanton: "Cantone fiscale",
    withholdingTaxDebtorNumber: "Numero debitore",
    withholdingTaxPeriodicity: "Periodicità dichiarazione",
    periodicityMonthly: "Mensile",
    periodicityQuarterly: "Trimestrale",
    periodicityAnnual: "Annuale",
    payFrequency: "Frequenza di pagamento",
    payFrequencyMonthly: "Mensile",
    payFrequencySemiMonthly: "Bimensile",
    payFrequencyWeekly: "Settimanale",
    missingActiveLaap: "Piano LAINF-P attivo con contributo datore",
    missingActiveLaanp: "Piano LAINF-NP attivo con contributo dipendente",
    missingActiveLpp: "Piano LPP attivo con fasce d'età",
    missingAvsFundName: "Nome cassa AVS",
    missingAvsAdminRate: "Contributo amministrativo AVS",
    missingFamilyAllowanceFundName: "Nome cassa assegni familiari",
    missingAvsAdminBase: "Base di calcolo delle spese amministrative AVS",
    missingFamilyAllowanceRate: "Tasso di contribuzione assegni familiari",
    administrationBase: "Base di calcolo delle spese",
    administrationBaseAvsContributions: "Contributi AVS/AI/IPG",
    administrationBaseGrossAvs: "Massa salariale soggetta AVS",
    administrationBaseHelp: "A seconda della vostra cassa, il tasso si applica al totale dei contributi AVS/AI/IPG oppure alla massa salariale lorda soggetta AVS. Questa informazione figura nel vostro conteggio della cassa.",
    familyAllowanceContributionRate: "Tasso di contribuzione datore di lavoro",
    familyAllowanceRateHelp: "Questo tasso dipende dalla cassa di affiliazione, non dal cantone. Due aziende nello stesso cantone affiliate a casse diverse pagano tassi diversi.",
    expenseRegulation: "Regolamento spese",
    expenseRegulationApproved: "Regolamento spese approvato",
    expenseRegulationCanton: "Cantone di approvazione",
    expenseRegulationDate: "Data di approvazione",
    expenseRegulationReference: "Numero di riferimento",
    withholdingTaxNote: "La configurazione dell'imposta alla fonte è parziale. Il supporto completo (consultazione tariffe, correzioni annuali) è previsto per una versione futura.",
    showPlanHistory: "Mostra cronologia",
    hidePlanHistory: "Nascondi cronologia",

    // Payroll — Payroll runs
    payrollRuns: "Cicli salariali",
    payrollRun: "Ciclo salariale",
    payslip: "Certificato di salario",
    payslips: "Certificati di salario",
    openPeriod: "Aprire un periodo",
    period: "Periodo",
    employeeCount: "Dipendenti",
    grossTotal: "Lordo",
    netTotal: "Netto",
    employerCost: "Costo del datore di lavoro",
    totalDeductions: "Trattenute",
    totalEmployerCharges: "Contributi del datore di lavoro",
    validatedAt: "Validato il",
    calculate: "Calcolare",
    recalculate: "Ricalcolare",
    validate: "Validare",
    markAsPaid: "Segna come pagato",
    cancelRun: "Annullare",
    regeneratePdfs: "Rigenerare i PDF",
    downloadSummary: "Scaricare il riepilogo",
    downloadPayslip: "Scaricare il certificato",
    calculating: "Calcolo in corso...",
    calculatingProgress: "Calcolo in corso. Potrebbe richiedere qualche minuto.",
    calculatingTimeout: "Il calcolo sta impiegando più tempo del previsto. Puoi riprovare.",
    retryCalculation: "Riprovare il calcolo",
    noPayrollRuns: "Nessun ciclo salariale",
    noPayslips: "Nessun certificato",
    createPayrollRun: "Aprire un periodo di paga",
    periodAlreadyExists: "Esiste già un ciclo salariale per questo periodo.",
    periodAlreadyExistsLink: "Visualizza il ciclo esistente",
    confirmValidateTitle: "Validare il ciclo salariale",
    confirmValidateBody: "{count} certificati — Lordo: {gross} — Netto: {net} — Costo datore: {employerCost}",
    confirmValidateIrreversible: "Questa azione è irreversibile. I certificati saranno congelati e i PDF generati. Qualsiasi correzione richiederà un annullamento o un adeguamento retroattivo.",
    confirmValidateFinalSettlements: "Questo ciclo contiene {count} conteggio/i finale/i.",
    confirmValidateNegativeNets: "Questo ciclo contiene {count} certificato/i con netto negativo.",
    confirmCancelTitle: "Annullare il ciclo salariale",
    cancellationReason: "Motivo dell'annullamento",
    cancellationReasonRequired: "Un motivo è richiesto per annullare un ciclo salariale.",
    confirmPayTitle: "Segna come pagato",
    confirmPayBody: "Conferma che {count} certificati per un totale di {net} netto sono stati pagati.",
    payslipProvisional: "Provvisorio — non ancora validato",
    provisional: "Provvisorio",
    interim: "Intermedio",
    ancillaryActivities: "Attività accessorie",
    extraordinaryItems: "Componenti straordinarie",
    payslipFailed: "Calcolo fallito",
    controlPanel: "Pannello di controllo",
    failedPayslips: "Certificati in errore",
    failedPayslipsBlocking: "Validazione bloccata: {count} certificato/i in errore.",
    excludedEmployees: "Dipendenti esclusi",
    runWarnings: "Segnalazioni",
    finalSettlements: "Conteggi finali",
    negativeNets: "Netti negativi",
    retroactiveOnly: "Solo retroattivi",
    runStatusDraft: "Bozza",
    runStatusCalculating: "In fase di calcolo",
    runStatusCalculated: "Calcolato",
    runStatusValidated: "Validato",
    runStatusPaid: "Pagato",
    runStatusCancelled: "Annullato",
    exclusionStatusDraft: "Dipendente in stato bozza",
    exclusionStatusTerminated: "Rapporto di lavoro terminato",
    exclusionNoContract: "Nessun contratto attivo",
    exclusionHireAfterPeriod: "Assunto dopo il periodo",
    exclusionContractEndedBeforePeriod: "Contratto terminato prima del periodo",
    warningLppNotVerifiableHourly: "I contributi LPP non hanno potuto essere verificati per i dipendenti a ore",
    warningPdfGenerationFailed: "Generazione PDF fallita per questo certificato",
    warningHasAbsence: "Questo dipendente ha assenze nel periodo",
    warningHourlyAbsenceNotDeducted: "Dipendente a ore con assenze — la deduzione non viene applicata automaticamente",
    warningHourlyZeroGross: "Dipendente a ore con salario lordo a zero",

    // Monthly declaration
    monthlyDeclaration: "Dichiarazione mensile",
    monthlyDeclarations: "Dichiarazioni mensili",
    socialInsuranceDays: "Giorni AS",
    absenceDays: "Giorni di assenza",
    effectiveWorkingDays: "Giorni lavorativi effettivi",
    workingHours: "Ore",
    absences: "Assenze",
    addAbsence: "Aggiungere un'assenza",
    editAbsence: "Modificare l'assenza",
    deleteAbsence: "Eliminare l'assenza",
    absenceOngoing: "In corso",
    daysRetained: "{days} giorno/i trattenuto/i",
    declarationValidated: "Validata",
    declarationDraft: "Bozza",
    validateDeclaration: "Validare la dichiarazione",
    validateAllDeclarations: "Validare tutte",
    saveDeclaration: "Salvare",
    noEligibleEmployees: "Nessun dipendente idoneo per questo ciclo",
    hourlyNoHoursWarning: "Dipendente a ore senza ore inserite — il cedolino sarà a zero",
    declarationNotValidated: "Dichiarazione non validata",
    recalculationNeeded: "Le variabili salariali sono state modificate dall'ultimo calcolo. Un ricalcolo è necessario prima della validazione.",
    loadError: "Errore nel caricamento dei dati",
    retry: "Riprova",
    punctualRubriques: "Voci puntuali",
    addRubrique: "Aggiungere una voce",
    removeRubrique: "Rimuovere",
    rubriqueCode: "Codice",
    rubriqueLabel: "Etichetta",
    rubriqueAmount: "Importo",
    rubriqueQuantity: "Quantità",
    rubriqueRate: "Tasso",
    rubriqueCalculationMode: "Modalità di calcolo",
    declarationFor: "Dichiarazione di {name}",
    backToRun: "Torna al ciclo",
    editDeclaration: "Inserire le variabili",
    activityRate: "Tasso di attività",
    noRubriques: "Nessuna rubrica puntuale",
    saveAndClose: "Salva e chiudi",

    // Absence reasons
    absenceReason: "Motivo dell'assenza",
    absenceReasonIllness: "Malattia",
    absenceReasonAccidentOccupational: "Infortunio professionale",
    absenceReasonAccidentNonOccupational: "Infortunio non professionale",
    absenceReasonMilitaryService: "Servizio militare",
    absenceReasonMaternity: "Maternità",
    absenceReasonPaternity: "Paternità",
    absenceReasonUnpaid: "Assenza non retribuita",
    absenceReasonUnjustified: "Assenza ingiustificata",
    incapacityRate: "Grado d'incapacità",
    salaryContinuationRate: "Continuazione del salario",
    absenceFrom: "Dal",
    absenceTo: "Al",
    absenceToHelp: "Lasciare vuoto se l'assenza è in corso",
    confirmDeleteAbsence: "Siete sicuri di voler eliminare questa assenza?",

    // Absence report
    absenceReport: "Rapporto assenze",
    absenceHistory: "Storico assenze",
    totalByReason: "Totale per motivo",
    noAbsences: "Nessuna assenza",
    filterByYear: "Filtrare per anno",
    filterByReason: "Filtrare per motivo",
    allReasons: "Tutti i motivi",
    goToPayrollRun: "Vedere il ciclo paga",
    companySnapshotIncomplete: "I dati aziendali sono incompleti (nome, indirizzo o numero IDE mancante). I PDF dei cedolini potrebbero essere compromessi.",
    companySettings: "Vai alle impostazioni aziendali",
    validateBlockedByFailures: "Validazione impossibile: ci sono certificati in errore",
    backToPayrollRuns: "Torna ai cicli salariali",
    year: "Anno",

    // Zod error map
    zodFieldRequired: "Questo campo è obbligatorio",
    zodInvalidType: "Valore non valido",
    zodTooShort: "Minimo {min} caratteri",
    zodTooLong: "Massimo {max} caratteri",
    zodNumberTooSmall: "Deve essere almeno {min}",
    zodNumberTooBig: "Deve essere al massimo {max}",
    zodArrayTooShort: "Almeno {min} elemento(i) richiesto(i)",
    zodInvalidEmail: "Indirizzo e-mail non valido",
    zodInvalidFormat: "Formato non valido",
    zodInvalidSelection: "Selezionare un'opzione valida",
    zodInvalidDate: "Data non valida",
    zodInvalidValue: "Valore non valido",

    // Reconciliation indicators
    reconciled: "Riconciliato",
    notReconciled: "Non riconciliato",
    filteredTotalsWarning: "I totali riflettono il filtro attivo, non l'intero conto",

    // Recurring contracts
    recurringContracts: "Contratti ricorrenti",
    recurringContract: "Contratto ricorrente",
    addRecurringContract: "Aggiungi contratto ricorrente",
    createRecurringContract: "Crea contratto ricorrente",
    updateRecurringContract: "Modifica contratto ricorrente",
    viewRecurringContract: "Dettagli contratto ricorrente",
    searchRecurringContract: "Cerca contratto...",
    allStatuses: "Tutti gli stati",
    frequency: "Frequenza",
    monthly: "Mensile",
    quarterly: "Trimestrale",
    semiAnnual: "Semestrale",
    annual: "Annuale",
    nextInvoiceDate: "Prossima fattura",
    generateInvoice: "Genera fattura",
    generateInvoiceConfirm: "Una fattura verrà creata da questo contratto.",
    invoiceGenerated: "Fattura generata",
    generatedInvoices: "Fatture generate",
    pause: "Sospendi",
    paused: "Sospeso",
    activate: "Attiva",
    changeStatusTo: "Cambia stato in",
    ended: "Terminato",
    every: "Ogni",
    quarters: "trimestri",
    anchorDay: "Giorno del mese",
    issueOffsetDays: "Anticipo emissione (giorni)",
    autoValidate: "Convalida automatica",
    autoSend: "Invio automatico",
    autoBilling: "Fatturazione automatica (convalidare e inviare)",
    autoBillingRequiresAccount: "Il servizio selezionato non ha un conto contabile configurato; la fatturazione automatica richiede un conto.",
    autoRenew: "Rinnovo automatico",
    autoRenewHint: "Rinnovare automaticamente il contratto alla scadenza",
    renewDaysBefore: "Giorni prima della scadenza",
    renewDaysBeforeHint: "Numero di giorni prima della scadenza per attivare il rinnovo automatico",
    renewNow: "Rinnova ora",
    renewConfirm: "Il contratto sarà esteso di un ulteriore periodo.",
    contractRenewed: "Contratto rinnovato",
    lifecycleHistory: "Storico del ciclo di vita",
    eventRenewed: "Rinnovato",
    eventEnded: "Terminato",
    triggerAuto: "Automatico",
    triggerManual: "Manuale",
    noLifecycleEvents: "Nessun evento",
    renewalCount: "Rinnovi",
    paymentTermsDays: "Termini di pagamento (giorni)",

    // Bank statement extraction retry
    retryExtraction: "Riprova estrazione",
    extractionFailedRetry: "Estrazione fallita. Puoi riprovare.",
    extractionEmptyRetry: "Estrazione completata ma nessuna riga trovata. Puoi riprovare.",
    extractionInProgress: "Estrazione in corso…",
    retrying: "Nuovo tentativo…",

    // Dunning policies
    dunningPolicies: "Politiche di sollecito",
    dunningLabelRequired: "Il nome della politica è obbligatorio",
    dunningStepsRequired: "È richiesto almeno un passaggio",
    editDunningPolicy: "Modifica politica di sollecito",
    addDunningPolicy: "Aggiungi politica di sollecito",
    appliesTo: "Si applica a",
    both: "Entrambi",
    setAsDefault: "Politica predefinita",
    stopAfterLastStep: "Ferma dopo l'ultimo passaggio",
    dunningSteps: "Fasi di sollecito",
    addStep: "Aggiungi fase",
    step: "Fase",
    offsetDays: "Scostamento (giorni dalla scadenza)",
    offsetDaysHint: "Negativo = prima della scadenza (promemoria di cortesia)",
    channel: "Canale",
    escalationTone: "Tono",
    templateKey: "Chiave modello",
    toneNeutral: "Neutro",
    toneFirm: "Deciso",
    toneFormal: "Formale",
    addLateFee: "Aggiungi spese di mora",
    lateFeeType: "Tipo di spesa",
    lateFeeFixed: "Importo fisso",
    lateFeeInterest: "Interessi di mora",
    lateFeeBoth: "Fisso + interessi",
    lateFeeLabel: "Etichetta sulla fattura",
    fixedAmount: "Importo fisso",
    annualRate: "Tasso annuale (%)",
    interestBase: "Base di calcolo",
    basePrincipal: "Importo principale",
    baseCurrent: "Importo corrente",
    dunningPolicy: "Politica di sollecito",
    noDunning: "Nessun sollecito",
    dunningPolicyHint: "Seleziona la politica di sollecito per questo documento",
    dunningConfigured: "Configurata",
    dunningRelances: "Solleciti",
    dunningActive: "Attivi",
    dunningSuspended: "Sospesi",
    dunningStopped: "Fermati",
    dunningUntil: "fino al",
    lateFee: "Spese",
    noDunningSent: "Nessun sollecito inviato finora.",
    suspendDunning: "Sospendere i solleciti?",
    resumeDunning: "Riprendere",
    stopDunning: "Fermare definitivamente i solleciti?",
    yesStop: "Sì, fermare",
    dunningWillPause: "I solleciti automatici saranno messi in pausa per questa fattura.",
    dunningStopIrreversible: "Questa fattura non sarà più sollecitata automaticamente.",
    dunningResumed: "Solleciti ripresi",

    // Subscription banner
    subscriptionTrialBanner: "Il tuo periodo di prova gratuito termina il {date} ({days} giorni rimanenti)",
    subscriptionPastDueBanner: "La tua fattura è scaduta. Regolarizza prima del {date} per evitare un'interruzione del servizio",
    subscriptionExpiredBanner: "Il tuo abbonamento è scaduto. L'accesso è in sola lettura. Rinnova per ripristinare l'accesso completo",
    subscriptionCancelledBanner: "Il tuo abbonamento termina il {date}",
    subscriptionDaysRemaining: "{days} giorni rimanenti",
    subscriptionPayNow: "Paga ora",
    subscriptionChoosePlan: "Scegli un piano",

    // Subscription & plan labels
    subscription: "Abbonamento",
    featureNotIncluded: "Non incluso nel piano attuale",
    featureRequiresPlan: "Disponibile dal piano {plan}",
    featureRequiresActiveSubscription: "È necessario un abbonamento attivo",
    featureViewOffers: "Visualizza i piani",
    featureRegularize: "Rinnova l'abbonamento",
    featureContactAdmin: "Contatta il tuo amministratore per effettuare l'upgrade",

    // Subscription management (F2)
    subscriptionMySubscription: "Il mio abbonamento",
    subscriptionOffers: "Piani e prezzi",
    subscriptionCurrentPlan: "Piano attuale",
    subscriptionFreePlan: "Gratuito",
    subscriptionBillingCycle: "Ciclo di fatturazione",
    subscriptionNextRenewal: "Prossimo rinnovo",
    subscriptionTrialEndsOn: "Il periodo di prova termina il {date}",
    subscriptionTrialDaysLeft: "{days} giorni rimanenti nel periodo di prova",
    subscriptionPendingChange: "Modifica in attesa",
    subscriptionPendingChangeDetail: "Passerai a {plan} il {date}",
    subscriptionCancelPendingChange: "Annulla questa modifica",
    subscriptionPendingChangeCancelled: "Modifica in attesa annullata",
    subscriptionCancelPendingConfirmTitle: "Annullare il cambio di piano?",
    subscriptionCancelPendingConfirmText: "Il vostro abbonamento resterà sul piano {currentPlan}. Il passaggio al piano {pendingPlan} non avrà luogo.",
    subscriptionQuotas: "Utilizzo e quote",
    subscriptionQuotaUsage: "{current} / {limit}",
    subscriptionUnlimited: "Illimitato",
    subscriptionChangePlan: "Cambia piano",
    subscriptionChooseMyOffer: "Scegli il mio piano",
    subscriptionPayMyInvoice: "Paga la mia fattura",
    subscriptionAnnualSavingsHint: "Risparmia il {percent}% con la fatturazione annuale",
    subscriptionCancelSubscription: "Annulla abbonamento",
    subscriptionReactivate: "Riattiva",
    subscriptionCancelConfirmTitle: "Annullare l'abbonamento?",
    subscriptionCancelConfirmText: "Manterrai l'accesso fino alla fine del periodo corrente. Dopo, il tuo abbonamento non verrà rinnovato.",
    subscriptionCancelledSuccess: "Il tuo abbonamento è stato annullato",
    subscriptionReactivatedSuccess: "Il tuo abbonamento è stato riattivato",
    subscriptionUpgrade: "Upgrade",
    subscriptionDowngrade: "Downgrade",
    subscriptionUpgradeConfirmTitle: "Passare a {plan}?",
    subscriptionUpgradeConfirmText: "Questa modifica ha effetto immediato. Ti verrà addebitato l'importo proporzionale.",
    subscriptionDowngradeConfirmTitle: "Passare a {plan}?",
    subscriptionDowngradeConfirmText: "Il tuo piano cambierà a {plan} il {date}. Mantieni tutte le funzionalità attuali fino ad allora.",
    subscriptionChangeSuccess: "Il tuo piano è stato aggiornato",
    subscriptionEffectImmediate: "Effetto immediato",
    subscriptionEffectAtDate: "Effettivo dal {date}",
    subscriptionYouWillBeCharged: "Importo da addebitare: {amount}",
    subscriptionProrataNotice: "Ti verrà addebitato l'importo proporzionale",
    subscriptionCompareOffers: "Confronta i piani",
    subscriptionYourCurrentPlan: "Il tuo piano",
    subscriptionSelectPlan: "Seleziona",
    subscriptionIncluded: "Incluso",
    subscriptionOptionalAddon: "Opzionale",
    subscriptionNotIncluded: "Non incluso",
    subscriptionCatalogUnavailable: "I piani non sono momentaneamente disponibili. Riprova più tardi.",
    subscriptionNoPricingForCycle: "Non disponibile per questo ciclo di fatturazione",
    subscriptionNoPlan: "Nessun piano attivo",
    subscriptionStatusActive: "Attivo",
    subscriptionStatusTrial: "Prova",
    subscriptionStatusPastDue: "Scaduto",
    subscriptionStatusExpired: "Scaduto",
    subscriptionStatusCancelled: "Annullato",
    subscriptionPerMonth: "/mese",
    subscriptionPerYear: "/anno",
    subscriptionEquivPerMonth: "/mese",
    subscriptionBilledPerYear: "Fatturato {amount}/anno",
    subscriptionSavingsPercent: "Risparmia {percent}%",
    featureComingSoon: "Prossimamente disponibile",

    // Upgrade modal (F6)
    subscriptionUpgradePlan: "Cambia piano",
    subscriptionWhatsInPlan: "Cosa include il piano {plan}?",
    subscriptionRecommended: "Consigliato",
    subscriptionFeatureRequiresUpgrade: "La funzionalità {feature} richiede un piano superiore.",
    payrollAccessDeniedPlanRequired: "Il modulo stipendi non è incluso nel piano attuale. Passa a un piano superiore per accedervi.",
    subscriptionModalTitleChoose: "Scegli il tuo piano",
    subscriptionModalTitleChange: "Cambia piano",
    subscriptionSubscribeAction: "Abbonati",
    subscriptionSwitchTo: "Passa a {plan}",
    subscriptionDowngradeTo: "Declassa a {plan}",
    subscriptionFeaturesAdded: "Funzionalità incluse",
    subscriptionFeaturesRemoved: "Funzionalità non incluse",
    subscriptionSeeAllFeatures: "Vedi tutte le funzionalità",
    subscriptionHideFeatures: "Nascondi funzionalità",

    // First-choice flow (Lot 4)
    subscriptionChooseTitle: "Scegli il tuo piano",
    subscriptionChooseSubtitle: "Seleziona un piano e le opzioni aggiuntive per iniziare.",
    subscriptionChooseConfirmTitle: "Conferma la tua scelta",
    subscriptionChooseConfirmText: "Stai per abbonarti al piano {plan} ({cycle}).",
    subscriptionChooseSuccess: "Il tuo piano è stato attivato",
    subscriptionChooseWithAddons: "con {count} opzione/i",
    subscriptionPriceSummary: "Riepilogo del prezzo",
    subscriptionPlanPrice: "Piano ({plan})",
    subscriptionAddonsTotal: "Opzioni aggiuntive",
    subscriptionSubtotalHT: "Subtotale IVA esclusa",
    subscriptionVatRate: "IVA ({rate} %)",
    subscriptionTotalTTC: "Totale IVA inclusa",
    subscriptionVatOnInvoiceNote: "Tutti i prezzi sono indicati IVA esclusa. L'IVA figurerà sulla fattura.",
    subscriptionConfirmChoice: "Conferma e abbonati",
    subscriptionWizardStepPlan: "Piano",
    subscriptionWizardStepAddons: "Opzioni",
    subscriptionWizardStepSummary: "Riepilogo",
    subscriptionWizardNext: "Avanti",
    subscriptionWizardBack: "Indietro",
    subscriptionWizardConfirmAndPay: "Conferma e paga",
    subscriptionAddonsLoading: "Caricamento delle opzioni disponibili…",
    subscriptionAddonsLoadError: "Impossibile caricare le opzioni. Riprovare.",
    subscriptionAddonsIncompatibleRemoved: "Alcune opzioni sono state rimosse perché non compatibili con il piano selezionato.",
    subscriptionTotalHT: "Totale IVA esclusa",
    subscriptionChangeTitle: "Cambia piano",
    subscriptionChangeSubtitle: "Seleziona un nuovo piano e opzioni facoltative.",
    subscriptionWizardConfirmChange: "Conferma il cambio",
    subscriptionConfirmedWaiting: "Il vostro abbonamento \u00e8 confermato. Stiamo preparando la vostra fattura\u2026",
    subscriptionInvoiceReady: "La vostra fattura \u00e8 pronta.",
    subscriptionTimeoutMessage: "Il vostro abbonamento \u00e8 confermato. La vostra fattura sar\u00e0 disponibile a breve sulla pagina dell\u2019abbonamento.",
    subscriptionDownloadingPdf: "Download in corso\u2026",
    subscriptionPlanDenied: "Questo piano non è disponibile per il tuo account.",
    subscriptionAddonBlocksChange: "Alcune opzioni selezionate non sono compatibili con questo piano. Deselezionarle prima.",
    subscriptionSelectAddons: "Opzioni facoltative",
    subscriptionNoAddonsSelected: "Nessuna opzione selezionata",
    subscriptionInvoiceNotice: "Una fattura vi sarà inviata {days} giorni prima dell'inizio dell'abbonamento.",
    subscriptionTrialUnchanged: "Il vostro periodo di prova gratuito resta attivo fino al {date}.",
    subscriptionPaymentFlexible: "Ogni fattura potrà essere pagata tramite QR-fattura o carta di credito — scegliete voi a ogni scadenza.",
    subscriptionTermsLink: "Condizioni generali di vendita",
    subscriptionRenewalNoticeMonthly: "Il vostro abbonamento sarà rinnovato automaticamente ogni mese al prezzo di {amount} IVA esclusa, salvo disdetta preventiva.",
    subscriptionRenewalNoticeYearly: "Il vostro abbonamento sarà rinnovato automaticamente ogni anno al prezzo di {amount} IVA esclusa, salvo disdetta preventiva.",
    subscriptionCancellationNotice: "Potete disdire il vostro abbonamento in qualsiasi momento da questa pagina. La disdetta ha effetto alla fine del periodo in corso — l'accesso è mantenuto fino a tale data.",

    // Trial-aware billing disclosures (Lot 3)
    subscriptionInvoiceIssuedNow: "La vostra fattura viene emessa immediatamente, da saldare entro il {date}.",
    subscriptionTrialUpgradeNotice: "Nuovo piano con effetto immediato. Fattura per la differenza di {amount} IVA esclusa, da saldare entro il {date}.",
    subscriptionTrialUpgradeOperatorNotice: "La vostra prima fattura sarà emessa alla tariffa di {plan}.",
    subscriptionTrialDowngradeNotice: "{plan} entrerà in vigore dal {date}. Il vostro primo periodo resta su {currentPlan}.",
    subscriptionCancelResiliation: "Annullare la disdetta",
    subscriptionCancelResiliationConfirmText: "Il vostro abbonamento continua e la fatturazione riprende normalmente.",
    subscriptionErrorNothingToUndo: "Non c'è alcuna disdetta in corso da annullare.",
    subscriptionCancelConfirmButton: "Sì, annullare l'abbonamento",
    subscriptionKeepSubscription: "Mantenere il mio abbonamento",
    subscriptionEndingNotice: "Il vostro abbonamento terminerà il {date}.",
    subscriptionAddonOnlyTrialNotice: "Le opzioni selezionate sono gratuite fino alla fine del periodo di prova il {date}. Nessuna fattura sarà emessa ora.",
    subscriptionAddonOnlyProrataNotice: "Una fattura proporzionale sarà generata per le opzioni selezionate.",
    subscriptionAddonOnlySuccess: "Le vostre opzioni sono state attivate con successo.",
    subscriptionErrorPlanChoiceRequired: "Scegliete prima un piano prima di apportare modifiche.",

    // Add-ons (F7 part C)
    addonSectionTitle: "Opzioni aggiuntive",
    addonAvailable: "Disponibile",
    addonActive: "Attivo",
    addonPendingCancellation: "Attivo — disattivazione a fine periodo",
    addonActivate: "Attivare",
    addonDeactivate: "Disattivare",
    addonActivateConfirmTitle: "Attivare {name}?",
    addonActivateConfirmText: "Questa opzione costa {price} e la fatturazione è immediata. Una fattura proporzionale sarà generata immediatamente. Non si tratta di una prova gratuita.",
    addonActivateConfirmTextTrial: "Questa opzione è gratuita fino alla fine del periodo di prova il {date}. Nessuna fattura sarà emessa ora. Dopo la prova, sarà fatturata a {price} insieme al piano.",
    addonActivateConfirmButton: "Attiva ora",
    addonActivatedSuccess: "{name} è ora attivo",
    addonActivatedInvoiceNotice: "La funzionalità è disponibile immediatamente. Una fattura proporzionale seguirà a breve.",
    addonActivatedInvoiceNoticeTrial: "La funzionalità è disponibile immediatamente, senza costi fino al {date}. La fatturazione inizierà con il piano.",
    addonDeactivateConfirmTitle: "Disattivare {name}?",
    addonDeactivateConfirmText: "L'opzione rimarrà attiva fino alla fine del periodo corrente ({date}). Non è previsto alcun rimborso — la fatturazione termina a fine periodo.",
    addonDeactivateConfirmButton: "Disattiva a fine periodo",
    addonDeactivatedSuccess: "{name} verrà disattivato alla fine del periodo corrente",
    addonAlreadyActive: "Questa opzione è già attiva",
    addonIncompatible: "Questa opzione non è compatibile con il piano attuale",
    addonNoPermission: "Non hai il permesso di gestire le opzioni aggiuntive. Contatta il tuo amministratore.",
    addonActiveUntil: "Attivo fino al {date}",
    addonBillingCycleMonthly: "al mese",
    addonBillingCycleYearly: "all'anno",
    addonBillingCycleOneTime: "una tantum",
    addonNoneAvailable: "Nessuna opzione aggiuntiva disponibile per il piano attuale.",
    addonManageAddons: "Gestisci opzioni",

    // Gated nav items — disabled tab tooltips
    navFeatureRequiresUpgrade: "Incluso in un piano superiore",
    navFeatureAvailableAsAddon: "Disponibile come opzione",

    // Billing — invoices & payments (F3)
    billingInvoices: "Fatture",
    billingInvoiceNumber: "Numero",
    billingInvoiceDate: "Data",
    billingInvoiceDueDate: "Scadenza",
    billingInvoiceAmount: "Importo",
    billingInvoiceStatus: "Stato",
    billingInvoiceStatusOpen: "Aperta",
    billingInvoiceStatusPaid: "Pagata",
    billingInvoiceStatusVoid: "Annullata",
    billingInvoiceStatusDraft: "Bozza",
    billingInvoiceStatusUncollectible: "Inesigibile",
    billingInvoiceOverdue: "In ritardo",
    billingPay: "Paga",
    billingDownloadPdf: "Scarica PDF",
    billingPaymentPending: "Pagamento in corso…",
    billingPayments: "Pagamenti",
    billingPaymentDate: "Data",
    billingPaymentAmount: "Importo",
    billingPaymentMethod: "Metodo",
    billingPaymentResult: "Risultato",
    billingPaymentSucceeded: "Riuscito",
    billingPaymentFailed: "Fallito",
    billingPaymentRefunded: "Rimborsato",
    billingPaymentFailureReason: "Motivo",
    billingPaymentRetry: "Riprova",
    billingPaymentMethods: "Metodi di pagamento",
    billingCardBrand: "Carta",
    billingCardEnding: "che termina con {last4}",
    billingCardExpires: "Scade {month}/{year}",
    billingCardExpiringSoon: "In scadenza",
    billingCardDefault: "Predefinito",
    billingAddPaymentMethod: "Aggiungi metodo di pagamento",
    billingDeletePaymentMethod: "Rimuovi",
    billingDeleteMethodConfirmTitle: "Rimuovere questo metodo di pagamento?",
    billingDeleteMethodConfirmText: "Questo metodo di pagamento verrà rimosso definitivamente.",
    billingDeleteDefaultMethodWarning: "Questo è il metodo di pagamento predefinito e la riscossione automatica è attiva. Rimuoverlo senza aggiungerne un altro farà fallire il prossimo addebito.",
    billingMethodDeleted: "Metodo di pagamento rimosso",
    billingNoInvoices: "Nessuna fattura per il momento",
    billingNoPayments: "Nessun pagamento per il momento",
    billingNoPaymentMethods: "Nessun metodo di pagamento registrato",
    billingUnavailable: "Le informazioni di fatturazione non sono momentaneamente disponibili. Riprova più tardi.",
    billingInvoiceDetail: "Dettaglio fattura",
    billingRelatedInvoice: "Fattura",
    paymentTitle: "Pagamento",
    paymentCompany: "Azienda",
    paymentInvoiceNumber: "Fattura",
    paymentAmount: "Importo",
    paymentDueDate: "Scadenza",
    paymentExpiry: "Valido fino al",
    paymentPayNow: "Paga ora",
    paymentRedirecting: "Reindirizzamento al fornitore di pagamento...",
    paymentLinkInvalid: "Questo link di pagamento non è più valido.",
    paymentLinkInvalidHint: "Contattaci se ritieni che si tratti di un errore.",
    paymentLinkExpiredTitle: "Questo link di pagamento è scaduto",
    paymentLinkExpiredDescription: "Questo link non è più valido. Torna alle tue fatture per richiederne uno nuovo.",
    paymentLinkExpiredAction: "Vai alle mie fatture",
    paymentProcessing: "Elaborazione del pagamento in corso...",
    paymentProcessingHint: "Attendere la conferma del pagamento.",
    paymentSucceeded: "Pagamento riuscito",
    paymentSucceededHint: "Il pagamento è stato elaborato. Puoi chiudere questa pagina.",
    paymentPending: "Pagamento in elaborazione",
    paymentPendingHint: "Il pagamento è in fase di elaborazione. Riceverai una conferma via e-mail a breve.",
    paymentFailed: "Pagamento non riuscito",
    paymentFailedHint: "Il pagamento non è andato a buon fine. Riprova o contattaci.",
    paymentCancelled: "Pagamento annullato",
    paymentCancelledHint: "Hai annullato il pagamento. Nessun importo è stato addebitato.",
    paymentStatusUnavailable: "Stato non disponibile",
    paymentStatusUnavailableHint: "Non è stato possibile recuperare lo stato del pagamento. Controlla la tua e-mail per la conferma.",
    paymentRetry: "Riprova il pagamento",
    paymentRetryExpired: "Questo link di pagamento è scaduto. Richiedine uno nuovo dalla lista fatture.",
    paymentBackToSubscription: "Torna al mio abbonamento",
    paymentRedirectingIn: "Reindirizzamento tra {0} s\u2026",
    paymentAmountPaid: "Importo pagato",
    paymentSignIn: "Accedi",
    paymentCheckAgain: "Verifica di nuovo",
    paymentNothingElseRequired: "La fattura è stata pagata. Non è richiesto nient'altro.",
    billingAmountDue: "Importo dovuto",
    billingAmountDueCount: "{count} fatture",
    billingDueDate: "Scadenza {date}",
    billingViewInvoices: "Visualizza fatture",
    billingPayAmount: "Paga {amount}",
    addonStepTitle: "Aggiungi opzioni al tuo piano",
    addonStepHint: "Queste opzioni sono compatibili con il tuo nuovo piano. Puoi aggiungerle anche in seguito.",
    addonStepSkip: "Salta",
    addonStepDone: "Continua",
    copy: "Copia",
    copied: "Copiato",
    showQrCode: "Mostra codice QR",
    scanToAddMeAsContact: "Scansiona questo codice dall'app mobile per aggiungermi come contatto",
    myDigitalAdminCode: "Il mio codice Digital Admin",
    uuidTypeMismatch: "Il tipo di UUID non corrisponde al tipo di contatto (persona/azienda)",
    uuidNotLinked: "Il contatto e stato creato, ma l'UUID fornito non corrisponde a nessun utente registrato",
    chatNoRegisteredContacts: "Nessun contatto registrato",
    chatRegisteredContactsHint: "I tuoi contatti con un account Digital Admin appaiono qui",
    chatMembersUnavailable: "Questa azienda non espone i suoi membri",
    chatSelectContact: "Seleziona un contatto",
    chatStartNewConversation: "Avvia una conversazione",
    manualEntryMatchesWarning: "Documenti o pagamenti corrispondono a questa riga bancaria. Preferire la riconciliazione dalla lista delle corrispondenze.",
    viewMatches: "Vedi corrispondenze",
    directChargeWarning: "Stai registrando un costo diretto. Se questo movimento paga una fattura fornitore esistente, usa la riconciliazione per non conteggiare il costo due volte.",
    directRevenueWarning: "Stai registrando un ricavo diretto. Se questo movimento incassa una fattura cliente esistente, usa la riconciliazione per non conteggiare il ricavo due volte.",

    // Assets (rental inventory)
    assets: "Beni",
    asset: "Bene",
    createAsset: "Crea bene",
    editAsset: "Modifica bene",
    listAssets: "Elenco beni",
    viewAsset: "Visualizza bene",
    assetName: "Nome del bene",
    assetCode: "Codice",
    assetDescription: "Descrizione",
    defaultDepositAmount: "Cauzione predefinita",
    acquisitionValue: "Valore di acquisizione",
    acquisitionDate: "Data di acquisizione",
    isDepreciable: "Ammortizzabile",
    residualValue: "Valore residuo",
    depreciationYears: "Periodo di ammortamento (anni)",
    depreciationSection: "Ammortamento",
    assetStatusAvailable: "Disponibile",
    assetStatusRented: "Affittato",
    assetStatusOutOfService: "Fuori servizio",
    currentTenant: "Inquilino attuale",
    rentedSince: "Affittato dal",
    rentedUntil: "Affittato fino al",
    searchAsset: "Cerca bene",
    youWantToDeleteTheAsset: "Vuoi eliminare questo bene?",
    assetDeletedSuccess: "Bene eliminato",
    assetCreatedSuccess: "Bene creato",
    assetUpdatedSuccess: "Bene aggiornato",
    assetStatusManagedByRental: "Lo stato è gestito dagli eventi di locazione",
    noAssetsFound: "Nessun bene trovato",
    rentAsset: "Affittare",
    rentThisAsset: "Affittare questo bene",
    tenant: "Inquilino",
    rentalCadence: "Frequenza di fatturazione",
    rentalStart: "Data di inizio",
    rentalEnd: "Data di fine",
    rentalDepositAmount: "Cauzione",
    confirmRental: "Conferma affitto",
    rentalCreatedSuccess: "Contratto di locazione creato",
    cadenceMonthly: "Mensile",
    cadenceQuarterly: "Trimestrale",
    cadenceAnnual: "Annuale",
    cadenceDay: "Giorno",
    cadenceWeek: "Settimana",
    cadenceMonth: "Mese",
    cadenceQuarter: "Trimestre",
    cadenceYear: "Anno",
    rentalOptions: "Opzioni di noleggio",
    addRentalOption: "Aggiungi opzione di noleggio",
    selectService: "Seleziona un servizio",
    rentalOption: "Opzione di noleggio",
    selectRentalOption: "Seleziona un'opzione di noleggio",
    noRentalOptionConfigured: "Questo bene non ha opzioni di noleggio configurate.",
    noRentalOption: "Nessuna opzione di noleggio",

    // Security deposit (caution)
    securityDeposit: "Cauzione",
    depositAmount: "Importo della cauzione",
    depositStatus: "Stato della cauzione",
    depositNone: "Nessuna",
    depositPending: "In attesa",
    depositReceived: "Ricevuta",
    depositPartiallyRetained: "Parzialmente trattenuta",
    depositReturned: "Restituita",
    receiveDeposit: "Registrare la ricezione",
    returnDeposit: "Restituire la cauzione",
    retainedAmount: "Importo trattenuto",
    returnedAmount: "Importo restituito",
    retainedAmountHint: "Importo trattenuto per danni",
    amountToReturn: "Importo da restituire",
    depositReceivedSuccess: "Ricezione della cauzione registrata",
    depositReturnedSuccess: "Cauzione restituita",
    receivedAt: "Ricevuta il",
    returnedAt: "Restituita il",
    depositMethod: "Metodo di pagamento",
    depositNote: "Nota",

    // Expense reports
    expenseReports: "Note spese",
    expenseReport: "Nota spese",
    expenseReportNumber: "N° nota",
    listExpenseReports: "Elenco note spese",
    createExpenseReport: "Crea nota spese",
    editExpenseReport: "Modifica nota spese",
    viewExpenseReport: "Visualizza nota spese",
    updateExpenseReport: "Aggiorna nota spese",
    submitted: "Inviata",
    validated: "Validata",
    submitExpenseReport: "Invia",
    rejectExpenseReport: "Rinvia per correzione",
    validateExpenseReport: "Convalida nota spese",
    rejectionReason: "Motivo del rifiuto",
    rejectionReasonPlaceholder: "Inserisci il motivo del rifiuto...",
    rejectionReasonRequired: "Un motivo di rifiuto è obbligatorio",
    rejectedReason: "Motivo del rifiuto",
    reimburse: "Rimborsare",
    createReimbursement: "Crea rimborso",
    createNewReimbursementForExpenseReport: "Crea nuovo rimborso per nota spese",
    employee: "Dipendente",
    merchant: "Commerciante",
    expenseDate: "Data spesa",
    youWantToDeleteThisExpenseReport: "Vuoi eliminare questa nota spese?",
    processOfCreatingANewExpenseReportCompleted: "Creazione di una nuova nota spese completata.",
    ifYouWantToSaveTheNewExpenseReport: "se desideri salvare la nuova nota spese.",
    processOfUpdatingAnExpenseReportCompleted: "Aggiornamento della nota spese completato.",
    thisExpenseReportHasNoPayments: "Questa nota spese non ha rimborsi.",
    youWantToSubmitThisExpenseReport: "Vuoi inviare questa nota spese?",
    expenseReportSubmittedSuccessfully: "Nota spese inviata con successo.",
    youWantToValidateThisExpenseReport: "Vuoi validare questa nota spese?",
    youWantToInvalidateThisExpenseReport: "Se invalidi questa nota spese, le scritture contabili associate verranno eliminate.",
    iban: "IBAN",
    receipt: "Ricevuta",
    attachReceipt: "Allega ricevuta",
    removeReceipt: "Rimuovi ricevuta",
    expenseLineDetails: "Dettagli della riga di spesa",
    newExpenseReport: "Nuova nota spese",
    descriptionCreateExpenseReport: "Inserisci i seguenti dati, necessari per creare una nuova nota spese.",
    pleaseModifyFieldsFromExpenseReport: "Modifica, aggiungi e/o elimina i campi che desideri dalla nota spese.",
    selectAnEmployee: "Selezionare un dipendente",
    beforeCreatingExpenseReport: "Prima di creare la nota spese",
    wouldYouLikeUploadPdfFilesToExpenseReport: "Desideri caricare file PDF per la nuova nota spese?",
    whenYouUploadPdfFilesTheyArePlacedAsExpenseReportLines: "Quando carichi file PDF, vengono posizionati come allegati giustificativi su ogni riga di spesa del modulo di creazione.",
    expenseBelongsToExpenseReport: "Questa spesa appartiene alla nota spese",
    expenseManagedFromReport: "Viene modificata e validata dalla nota spese.",

    // Write-off (stralcio a perdita)
    chargedOff: "Stralciata a perdita",
    writeOff: "Stralciare a perdita",
    writeOffInvoice: "Stralciare la fattura a perdita",
    writeOffAmount: "Importo da stralciare",
    writeOffDate: "Data dello stralcio",
    writeOffLossAccount: "Conto di perdita",
    writeOffReason: "Motivo",
    writeOffReasonRequired: "Un motivo è obbligatorio",
    writeOffConfirmMessage: "Questa fattura sarà stralciata a perdita per",
    writeOffVatCorrectionMessage: "L'IVA di {amount} sarà corretta (cifra 235).",
    writeOffSuccess: "Fattura stralciata a perdita con successo",
    writeOffCancelConfirm: "Vuoi annullare questo stralcio a perdita?",
    writeOffCancelSuccess: "Stralcio a perdita annullato con successo",
    writeOffs: "Stralci a perdita",
    writeOffAmountExceedsDebt: "L'importo supera il debito residuo",
    invoiceAlreadyChargedOff: "Questa fattura è già stralciata a perdita",

    // Expense access (employee)
    expenseAccess: "Accesso alle note spese",
    expenseAccessAuto: "Automatico (in base allo stato)",
    expenseAccessForcedOn: "Sempre autorizzato",
    expenseAccessForcedOff: "Mai autorizzato",
    expenseAccessHelp: "Automatico: autorizzato se il dipendente è in corso di impiego (bozza o attivo). Sempre/Mai: forzano l'accesso indipendentemente dallo stato.",
  },
};
